(window.webpackJsonp=window.webpackJsonp||[]).push([[16],{
/***/"3teY":
/***/function(e,t,i){"use strict";
/* harmony import */i("9slb"),i("C2xc")
/* harmony import */},
/***/"82cM":
/***/function(e,t,i){"use strict";
/* harmony import */i("h/KH"),i("fBRI"),i("y+0W"),i("LMqt")
/* harmony import */;const o=i("o5Wi").a`<dom-module id="lumo-combo-box-item" theme-for="vaadin-combo-box-item"><template><style include="lumo-item">:host{cursor:default;-webkit-tap-highlight-color:var(--lumo-primary-color-10pct);padding-left:calc(var(--lumo-border-radius)/ 4);padding-right:calc(var(--lumo-space-l) + var(--lumo-border-radius)/ 4);transition:background-color .1s;border-radius:var(--lumo-border-radius);overflow:hidden;--_lumo-item-selected-icon-display:block}:host::before{display:block}:host(:hover){background-color:var(--lumo-primary-color-10pct)}:host([focused]:not([disabled])){box-shadow:inset 0 0 0 2px var(--lumo-primary-color-50pct)}@media (pointer:coarse){:host(:hover){background-color:transparent}:host([focused]:not([disabled])){box-shadow:none}}:host([dir=rtl]){padding-right:calc(var(--lumo-border-radius)/ 4);padding-left:calc(var(--lumo-space-l) + var(--lumo-border-radius)/ 4)}</style></template></dom-module>`;document.head.appendChild(o.content)},
/***/"9slb":
/***/function(e,t,i){"use strict";
/* harmony import */i("M+Kv"),i("C2xc")
/* harmony import */},
/***/"C/Bj":
/***/function(e,t,i){"use strict";
/* unused harmony export ComboBoxLightElement */
/* harmony import */var o=i("F3iu"),s=i("8u2h"),r=i("Giub"),n=i("fRKg"),a=(i("a+0f"),i("o5Wi")),l=i("BTBx");
/* harmony import */
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * `<vaadin-combo-box-light>` is a customizable version of the `<vaadin-combo-box>` providing
 * only the dropdown functionality and leaving the input field definition to the user.
 *
 * The element has the same API as `<vaadin-combo-box>`.
 *
 * To create a custom input field, you need to add a child element which has a two-way
 * data-bindable property representing the input value. The property name is expected
 * to be `value` by default. See the example below for a simplest possible example
 * using a `<vaadin-text-field>` element.
 *
 * ```html
 * <vaadin-combo-box-light>
 *   <vaadin-text-field>
 *   </vaadin-text-field>
 * </vaadin-combo-box-light>
 * ```
 *
 * If you are using other custom input fields like `<iron-input>`, you
 * need to define the name of the bindable property with the `attrForValue` attribute.
 *
 * ```html
 * <vaadin-combo-box-light attr-for-value="bind-value">
 *   <iron-input>
 *     <input>
 *   </iron-input>
 * </vaadin-combo-box-light>
 * ```
 *
 * In the next example you can see how to create a custom input field based
 * on a `<paper-input>` decorated with a custom `<iron-icon>` and
 * two `<paper-button>`s to act as the clear and toggle controls.
 *
 * ```html
 * <vaadin-combo-box-light>
 *   <paper-input label="Elements" class="input">
 *     <iron-icon icon="toll" slot="prefix"></iron-icon>
 *     <paper-button slot="suffix" class="clear-button">Clear</paper-button>
 *     <paper-button slot="suffix" class="toggle-button">Toggle</paper-button>
 *   </paper-input>
 * </vaadin-combo-box-light>
 * ```
 * @extends PolymerElement
 * @mixes ComboBoxDataProviderMixin
 * @mixes ComboBoxMixin
 * @mixes ThemableMixin
 */
class d extends(Object(s.a)(Object(n.a)(Object(r.a)(o.a)))){static get template(){return a.a`<style>:host([opened]){pointer-events:auto}</style><slot></slot><vaadin-combo-box-dropdown-wrapper id="overlay" opened="[[opened]]" position-target="[[inputElement]]" renderer="[[renderer]]" _focused-index="[[_focusedIndex]]" _item-id-path="[[itemIdPath]]" _item-label-path="[[itemLabelPath]]" loading="[[loading]]" theme="[[theme]]"></vaadin-combo-box-dropdown-wrapper>`}static get is(){return"vaadin-combo-box-light"}static get properties(){return{
/**
       * Name of the two-way data-bindable property representing the
       * value of the custom input field.
       * @attr {string} attr-for-value
       * @type {string}
       */
attrForValue:{type:String,value:"value"},
/**
       * @type {!Element | undefined}
       */
inputElement:{type:Element,readOnly:!0}}}constructor(){super(),this._boundInputValueChanged=this._inputValueChanged.bind(this),this.__boundInputValueCommitted=this.__inputValueCommitted.bind(this)}
/** @protected */ready(){super.ready(),this._toggleElement=this.querySelector(".toggle-button"),this._clearElement=this.querySelector(".clear-button"),this._clearElement&&this._clearElement.addEventListener("mousedown",e=>{e.preventDefault(),// Prevent native focus changes
// _focusableElement is needed for paper-input
(this.inputElement._focusableElement||this.inputElement).focus()})}
/**
   * @return {boolean}
   */get focused(){return this.getRootNode().activeElement===this.inputElement}
/** @protected */connectedCallback(){super.connectedCallback();this._setInputElement(this.querySelector("vaadin-text-field,iron-input,paper-input,.paper-input-input,.input")),this._revertInputValue(),this.inputElement.addEventListener("input",this._boundInputValueChanged),this.inputElement.addEventListener("change",this.__boundInputValueCommitted),this._preventInputBlur()}
/** @protected */disconnectedCallback(){super.disconnectedCallback(),this.inputElement.removeEventListener("input",this._boundInputValueChanged),this.inputElement.removeEventListener("change",this.__boundInputValueCommitted),this._restoreInputBlur()}
/** @private */__inputValueCommitted(e){
// Detect if the input was cleared (by clicking the clear button on a vaadin-text-field)
// and propagate the value change to combo box value immediately.
e.__fromClearButton&&this._clear()}
/**
   * @return {string}
   * @protected
   */get _propertyForValue(){return Object(l.b)(this.attrForValue)}
/**
   * @return {string}
   * @protected
   */get _inputElementValue(){return this.inputElement&&this.inputElement[this._propertyForValue]}
/**
   * @param {string} value
   * @protected
   */set _inputElementValue(e){this.inputElement&&(this.inputElement[this._propertyForValue]=e)}}customElements.define(d.is,d)},
/***/C2xc:
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return h}));
/* harmony import */var o=i("F3iu"),s=i("nduU"),r=i("8u2h"),n=i("6kUO"),a=i("OVu0"),l=i("o5Wi"),d=i("hLn4");
/* harmony import */
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * `<vaadin-button>` is a Web Component providing an accessible and customizable button.
 *
 * ```html
 * <vaadin-button>
 * </vaadin-button>
 * ```
 *
 * ```js
 * document.querySelector('vaadin-button').addEventListener('click', () => alert('Hello World!'));
 * ```
 *
 * ### Styling
 *
 * The following shadow DOM parts are exposed for styling:
 *
 * Part name | Description
 * ----------------|----------------
 * `label` | The label (text) inside the button
 * `prefix` | A slot for e.g. an icon before the label
 * `suffix` | A slot for e.g. an icon after the label
 *
 *
 * The following attributes are exposed for styling:
 *
 * Attribute | Description
 * --------- | -----------
 * `active` | Set when the button is pressed down, either with mouse, touch or the keyboard.
 * `disabled` | Set when the button is disabled.
 * `focus-ring` | Set when the button is focused using the keyboard.
 * `focused` | Set when the button is focused.
 *
 * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
 *
 * @extends PolymerElement
 * @mixes ElementMixin
 * @mixes ControlStateMixin
 * @mixes ThemableMixin
 * @mixes GestureEventListeners
 * @demo demo/index.html
 */
class h extends(Object(a.a)(Object(n.a)(Object(r.a)(Object(s.a)(o.a))))){static get template(){return l.a`<style>:host{display:inline-block;position:relative;outline:0;white-space:nowrap}:host([hidden]){display:none!important}.vaadin-button-container::before{content:"\\2003";display:inline-block;width:0}.vaadin-button-container{display:inline-flex;align-items:center;justify-content:center;text-align:center;width:100%;height:100%;min-height:inherit;text-shadow:inherit;-webkit-user-select:none;-moz-user-select:none;user-select:none}[part=prefix],[part=suffix]{flex:none}[part=label]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}#button{position:absolute;top:0;left:0;right:0;width:100%;height:100%;opacity:0;cursor:inherit}</style><div class="vaadin-button-container"><div part="prefix"><slot name="prefix"></slot></div><div part="label"><slot></slot></div><div part="suffix"><slot name="suffix"></slot></div></div><button id="button" type="button"></button>`}static get is(){return"vaadin-button"}static get version(){return"2.4.0"}ready(){super.ready(),// Leaving default role in the native button, makes navigation announcement
// being different when using focus navigation (tab) versus using normal
// navigation (arrows). The first way announces the label on a button
// since the focus is moved programmatically, and the second on a group.
this.setAttribute("role","button"),this.$.button.setAttribute("role","presentation"),this._addActiveListeners(),// Fix for https://github.com/vaadin/vaadin-button-flow/issues/120
window.ShadyDOM&&window.ShadyDOM.flush()}
/**
   * @protected
   */disconnectedCallback(){super.disconnectedCallback(),// `active` state is preserved when the element is disconnected between keydown and keyup events.
// reproducible in `<vaadin-date-picker>` when closing on `Cancel` or `Today` click.
this.hasAttribute("active")&&this.removeAttribute("active")}
/** @private */_addActiveListeners(){Object(d.a)(this,"down",()=>!this.disabled&&this.setAttribute("active","")),Object(d.a)(this,"up",()=>this.removeAttribute("active")),this.addEventListener("keydown",e=>!this.disabled&&[13,32].indexOf(e.keyCode)>=0&&this.setAttribute("active","")),this.addEventListener("keyup",()=>this.removeAttribute("active")),this.addEventListener("blur",()=>this.removeAttribute("active"))}
/**
   * @protected
   * @return {Element}
   */get focusElement(){return this.$.button}}customElements.define(h.is,h)},
/***/"EgM/":
/***/function(e,t,i){"use strict";
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-lumo-styles/color.js?babel-target=es6
i("h/KH"),i("y+0W");
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-lumo-styles/style.js?babel-target=es6
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-checkbox/theme/lumo/vaadin-checkbox-styles.js?babel-target=es6
const o=i("o5Wi").a`<dom-module id="lumo-checkbox" theme-for="vaadin-checkbox"><template><style include="lumo-checkbox-style lumo-checkbox-effects">::-ms-backdrop,[part=checkbox]{line-height:1}</style></template></dom-module><dom-module id="lumo-checkbox-style"><template><style>:host{-webkit-tap-highlight-color:transparent;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default;outline:0}[part=label]:not([empty]){margin:.1875em .875em .1875em .375em}[part=checkbox]{width:calc(1em + 2px);height:calc(1em + 2px);margin:.1875em;position:relative;border-radius:var(--lumo-border-radius-s);background-color:var(--lumo-contrast-20pct);transition:transform .2s cubic-bezier(.12,.32,.54,2),background-color .15s;pointer-events:none;line-height:1.2}:host([checked]) [part=checkbox],:host([indeterminate]) [part=checkbox]{background-color:var(--lumo-primary-color)}[part=checkbox]::before{content:"\\2003"}[part=checkbox]::after{content:"";display:inline-block;width:0;height:0;border:0 solid var(--lumo-primary-contrast-color);border-width:.1875em 0 0 .1875em;box-sizing:border-box;transform-origin:0 0;position:absolute;top:.8125em;left:.5em;transform:scale(.55) rotate(-135deg);opacity:0}:host([checked]) [part=checkbox]::after{opacity:1;width:.625em;height:1.0625em}:host([indeterminate]) [part=checkbox]::after{transform:none;opacity:1;top:45%;height:10%;left:22%;right:22%;width:auto;border:0;background-color:var(--lumo-primary-contrast-color);transition:opacity .25s}:host([focus-ring]) [part=checkbox]{box-shadow:0 0 0 3px var(--lumo-primary-color-50pct)}:host([disabled]){pointer-events:none;color:var(--lumo-disabled-text-color)}:host([disabled]) [part=label] ::slotted(*){color:inherit}:host([disabled]) [part=checkbox]{background-color:var(--lumo-contrast-10pct)}:host([disabled]) [part=checkbox]::after{border-color:var(--lumo-contrast-30pct)}:host([indeterminate][disabled]) [part=checkbox]::after{background-color:var(--lumo-contrast-30pct)}:host([dir=rtl]) [part=label]:not([empty]){margin:.1875em .375em .1875em .875em}</style></template></dom-module><dom-module id="lumo-checkbox-effects"><template><style>:host(:hover) [part=checkbox]::after{transition:width .1s,height .25s}[part=checkbox]::before{color:transparent;display:inline-block;width:100%;height:100%;border-radius:inherit;background-color:inherit;transform:scale(1.4);opacity:0;transition:transform .1s,opacity .8s}:host(:not([checked]):not([indeterminate]):not([disabled]):hover) [part=checkbox]{background-color:var(--lumo-contrast-30pct)}@media (pointer:coarse){:host(:not([checked]):not([indeterminate]):not([disabled]):hover) [part=checkbox]{background-color:var(--lumo-contrast-20pct)}}:host([active]) [part=checkbox]{transform:scale(.9);transition-duration:50ms}:host([active][checked]) [part=checkbox]{transform:scale(1.1)}:host([active]:not([checked])) [part=checkbox]::before{transition-duration:10ms,10ms;transform:scale(0);opacity:.4}</style></template></dom-module>`;document.head.appendChild(o.content);
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-checkbox/src/vaadin-checkbox.js?babel-target=es6
i("lFcJ");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-checkbox/theme/lumo/vaadin-checkbox.js?babel-target=es6
/***/},
/***/Giub:
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return c}));
/* harmony import */var o=i("Y40L"),s=i("9nmN"),r=i("WE4f"),n=i("LDKE"),a=i("F0SK"),l=i("78gc"),d=i("6hLg"),h=i("Yz1v");
/* harmony import */
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * @polymerMixin
 */
const c=e=>class extends e{static get properties(){return{
/**
       * True if the dropdown is open, false otherwise.
       * @type {boolean}
       */
opened:{type:Boolean,notify:!0,value:!1,reflectToAttribute:!0,observer:"_openedChanged"},
/**
       * Set true to prevent the overlay from opening automatically.
       * @attr {boolean} auto-open-disabled
       */
autoOpenDisabled:Boolean,
/**
       * Set to true to disable this element.
       * @type {boolean}
       */
disabled:{type:Boolean,value:!1,reflectToAttribute:!0},
/**
       * When present, it specifies that the element field is read-only.
       * @type {boolean}
       */
readonly:{type:Boolean,value:!1,reflectToAttribute:!0},
/**
       * Custom function for rendering the content of every item.
       * Receives three arguments:
       *
       * - `root` The `<vaadin-combo-box-item>` internal container DOM element.
       * - `comboBox` The reference to the `<vaadin-combo-box>` element.
       * - `model` The object with the properties related with the rendered
       *   item, contains:
       *   - `model.index` The index of the rendered item.
       *   - `model.item` The item.
       * @type {ComboBoxRenderer | undefined}
       */
renderer:Function,
/**
       * A full set of items to filter the visible options from.
       * The items can be of either `String` or `Object` type.
       * @type {!Array<!ComboBoxItem | string> | undefined}
       */
items:{type:Array,observer:"_itemsChanged"},
/**
       * If `true`, the user can input a value that is not present in the items list.
       * `value` property will be set to the input value in this case.
       * Also, when `value` is set programmatically, the input value will be set
       * to reflect that value.
       * @attr {boolean} allow-custom-value
       * @type {boolean}
       */
allowCustomValue:{type:Boolean,value:!1},
/**
       * A subset of items, filtered based on the user input. Filtered items
       * can be assigned directly to omit the internal filtering functionality.
       * The items can be of either `String` or `Object` type.
       * @type {!Array<!ComboBoxItem | string> | undefined}
       */
filteredItems:{type:Array},
/**
       * The `String` value for the selected item of the combo box. Provides
       * the value for `iron-form`.
       *
       * When there’s no item selected, the value is an empty string.
       *
       * Use `selectedItem` property to get the raw selected item from
       * the `items` array.
       * @type {string}
       */
value:{type:String,observer:"_valueChanged",notify:!0,value:""},
/**
       * Used to detect user value changes and fire `change` events.
       * @private
       */
_lastCommittedValue:String,
/**
       * When set to `true`, "loading" attribute is added to host and the overlay element.
       * @type {boolean}
       */
loading:{type:Boolean,value:!1,reflectToAttribute:!0},
/**
       * @type {number}
       * @protected
       */
_focusedIndex:{type:Number,value:-1},
/**
       * Filtering string the user has typed into the input field.
       * @type {string}
       */
filter:{type:String,value:"",notify:!0},
/**
       * The selected item from the `items` array.
       * @type {ComboBoxItem | string | undefined}
       */
selectedItem:{type:Object,notify:!0},
/**
       * Path for label of the item. If `items` is an array of objects, the
       * `itemLabelPath` is used to fetch the displayed string label for each
       * item.
       *
       * The item label is also used for matching items when processing user
       * input, i.e., for filtering and selecting items.
       *
       * When using item templates, the property is still needed because it is used
       * for filtering, and for displaying the selected item value in the input box.
       * @attr {string} item-label-path
       * @type {string}
       */
itemLabelPath:{type:String,value:"label",observer:"_itemLabelPathChanged"},
/**
       * Path for the value of the item. If `items` is an array of objects, the
       * `itemValuePath:` is used to fetch the string value for the selected
       * item.
       *
       * The item value is used in the `value` property of the combo box,
       * to provide the form value.
       * @attr {string} item-value-path
       * @type {string}
       */
itemValuePath:{type:String,value:"value"},
/**
       * Path for the id of the item. If `items` is an array of objects,
       * the `itemIdPath` is used to compare and identify the same item
       * in `selectedItem` and `filteredItems` (items given by the
       * `dataProvider` callback).
       * @attr {string} item-id-path
       */
itemIdPath:String,
/**
       * The name of this element.
       */
name:{type:String},
/**
       * Set to true if the value is invalid.
       * @type {boolean}
       */
invalid:{type:Boolean,reflectToAttribute:!0,notify:!0,value:!1},
/**
       * @type {!HTMLElement | undefined}
       * @protected
       */
_toggleElement:Object,
/**
       * @type {!HTMLElement | undefined}
       * @protected
       */
_clearElement:Object,
/** @protected */
_inputElementValue:String,
/** @private */
_closeOnBlurIsPrevented:Boolean,
/** @private */
_previousDocumentPointerEvents:String,
/** @private */
_itemTemplate:Object}}static get observers(){return["_filterChanged(filter, itemValuePath, itemLabelPath)","_itemsOrPathsChanged(items.*, itemValuePath, itemLabelPath)","_filteredItemsChanged(filteredItems.*, itemValuePath, itemLabelPath)","_templateOrRendererChanged(_itemTemplate, renderer)","_loadingChanged(loading)","_selectedItemChanged(selectedItem, itemValuePath, itemLabelPath)","_toggleElementChanged(_toggleElement)"]}constructor(){super(),this._boundOnFocusout=this._onFocusout.bind(this),this._boundOverlaySelectedItemChanged=this._overlaySelectedItemChanged.bind(this),this._boundClose=this.close.bind(this),this._boundOnOpened=this._onOpened.bind(this),this._boundOnKeyDown=this._onKeyDown.bind(this),this._boundOnClick=this._onClick.bind(this),this._boundOnOverlayTouchAction=this._onOverlayTouchAction.bind(this),this._boundOnTouchend=this._onTouchend.bind(this)}
/** @protected */ready(){super.ready(),this.addEventListener("focusout",this._boundOnFocusout),this._lastCommittedValue=this.value,a.a.requestAvailability(),// 2.0 does not support 'overlay.selection-changed' syntax in listeners
this.$.overlay.addEventListener("selection-changed",this._boundOverlaySelectedItemChanged),this.addEventListener("vaadin-combo-box-dropdown-closed",this._boundClose),this.addEventListener("vaadin-combo-box-dropdown-opened",this._boundOnOpened),this.addEventListener("keydown",this._boundOnKeyDown),this.addEventListener("click",this._boundOnClick),this.$.overlay.addEventListener("vaadin-overlay-touch-action",this._boundOnOverlayTouchAction),this.addEventListener("touchend",this._boundOnTouchend),this._observer=new d.a(this,e=>{this._setTemplateFromNodes(e.addedNodes)});const e=e=>{const t=this.$.overlay,i=t&&t.$.dropdown;// Check dropdown.$ because overlay is lazily instantiated
i&&i.$&&this.$.overlay.$.dropdown.$.overlay.bringToFront&&requestAnimationFrame(()=>{i.$.overlay.bringToFront()})};this.addEventListener("mousedown",e),this.addEventListener("touchstart",e)}
/**
   * Manually invoke existing renderer.
   */render(){this.$.overlay._selector&&this.$.overlay._selector.querySelectorAll("vaadin-combo-box-item").forEach(e=>e._render())}
/** @private */_setTemplateFromNodes(e){this._itemTemplate=e.filter(e=>e.localName&&"template"===e.localName)[0]||this._itemTemplate}
/** @private */_removeNewRendererOrTemplate(e,t,i,o){e!==t?this._itemTemplate=void 0:i!==o&&(this.renderer=void 0)}
/** @private */_templateOrRendererChanged(e,t){if(e&&t)throw this._removeNewRendererOrTemplate(e,this._oldTemplate,t,this._oldRenderer),new Error("You should only use either a renderer or a template for combo box items");this._oldTemplate=e,this._oldRenderer=t}
/**
   * Opens the dropdown list.
   */open(){
// Prevent _open() being called when input is disabled or read-only
this.disabled||this.readonly||(this.opened=!0)}
/**
   * Closes the dropdown list.
   */close(){this.opened=!1}
/** @private */_openedChanged(e,t){
// Prevent _close() being called when opened is set to its default value (false).
void 0!==t&&(this.opened?(this._openedWithFocusRing=this.hasAttribute("focus-ring")||this.focusElement&&this.focusElement.hasAttribute("focus-ring"),// For touch devices, we don't want to popup virtual keyboard unless input is explicitly focused by the user.
this.hasAttribute("focused")||this.$.overlay.touchDevice||this.focus()):(this._onClosed(),this._openedWithFocusRing&&this.hasAttribute("focused")&&this.focusElement.setAttribute("focus-ring","")))}
/** @private */_onOverlayTouchAction(e){
// On touch devices, blur the input on touch start inside the overlay, in order to hide
// the virtual keyboard. But don't close the overlay on this blur.
this._closeOnBlurIsPrevented=!0,this.inputElement.blur(),this._closeOnBlurIsPrevented=!1}
/** @private */_onClick(e){this._closeOnBlurIsPrevented=!0;const t=e.composedPath();-1!==t.indexOf(this._clearElement)||"clear-button"===t[0].getAttribute("part")?(this._clear(),this.focus()):-1!==t.indexOf(this.inputElement)&&(t.indexOf(this._toggleElement)>-1&&this.opened?this.close():(t.indexOf(this._toggleElement)>-1||!this.autoOpenDisabled)&&this.open()),this._closeOnBlurIsPrevented=!1}
/**
   * Keyboard navigation
   * @private
   */_onKeyDown(e){this._isEventKey(e,"down")?(this._closeOnBlurIsPrevented=!0,this._onArrowDown(),this._closeOnBlurIsPrevented=!1,// prevent caret from moving
e.preventDefault()):this._isEventKey(e,"up")?(this._closeOnBlurIsPrevented=!0,this._onArrowUp(),this._closeOnBlurIsPrevented=!1,// prevent caret from moving
e.preventDefault()):this._isEventKey(e,"enter")?this._onEnter(e):this._isEventKey(e,"esc")&&this._onEscape(e)}
/**
   * @param {!KeyboardEvent} event
   * @param {string} key
   * @return {boolean}
   * @protected
   */_isEventKey(e,t){return l.a.keyboardEventMatchesKeys(e,t)}
/** @private */_getItemLabel(e){return this.$.overlay.getItemLabel(e)}
/** @private */_getItemValue(e){let t=e&&this.itemValuePath?this.get(this.itemValuePath,e):void 0;return void 0===t&&(t=e?e.toString():""),t}
/** @private */_onArrowDown(){this.opened?this.$.overlay._items&&(this._focusedIndex=Math.min(this.$.overlay._items.length-1,this._focusedIndex+1),this._prefillFocusedItemLabel()):this.open()}
/** @private */_onArrowUp(){this.opened?(this._focusedIndex>-1?this._focusedIndex=Math.max(0,this._focusedIndex-1):this.$.overlay._items&&(this._focusedIndex=this.$.overlay._items.length-1),this._prefillFocusedItemLabel()):this.open()}
/** @private */_prefillFocusedItemLabel(){this._focusedIndex>-1&&(
// Reset the input value asyncronously to prevent partial value changes
// announce. Makes OSX VoiceOver to announce the complete value instead.
this._inputElementValue="",// 1ms delay needed for OSX VoiceOver to realise input value was reset
setTimeout(()=>{this._inputElementValue=this._getItemLabel(this.$.overlay._focusedItem),this._markAllSelectionRange()},1))}
/** @private */_setSelectionRange(e,t){
// vaadin-text-field does not implement setSelectionRange, hence we need the native input
const i=this._nativeInput||this.inputElement;// Setting selection range focuses and/or moves the caret in some browsers,
// and there's no need to modify the selection range if the input isn't focused anyway.
// This affects Safari. When the overlay is open, and then hiting tab, browser should focus
// the next focusable element instead of the combo-box itself.
// Checking the focused property here is enough instead of checking the activeElement.
if(this.hasAttribute("focused")&&i&&i.setSelectionRange)try{i.setSelectionRange(e,t)}catch(e){// IE11 randomly fails when running tests in Sauce.
}}
/** @private */_markAllSelectionRange(){void 0!==this._inputElementValue&&this._setSelectionRange(0,this._inputElementValue.length)}
/** @private */_clearSelectionRange(){if(void 0!==this._inputElementValue){const e=this._inputElementValue?this._inputElementValue.length:0;this._setSelectionRange(e,e)}}
/** @private */_closeOrCommit(){this.opened||this.loading?this.close():this._commitValue()}
/** @private */_onEnter(e){
// should close on enter when custom values are allowed, input field is cleared, or when an existing
// item is focused with keyboard. If auto open is disabled, under the same conditions, commit value.
(this.opened||this.autoOpenDisabled)&&(this.allowCustomValue||""===this._inputElementValue||this._focusedIndex>-1)&&(this._closeOrCommit(),// Do not submit the surrounding form.
e.preventDefault(),// Do not trigger global listeners
e.stopPropagation())}
/**
   * @param {!KeyboardEvent} e
   * @protected
   */_onEscape(e){this.autoOpenDisabled?
// Auto-open is disabled
this.opened||this.value!==this._inputElementValue&&this._inputElementValue.length>0?(
// The overlay is open or
// the input value has changed but the change hasn't been committed, so cancel it.
this._stopPropagation(e),this._focusedIndex=-1,this.cancel()):this.clearButtonVisible&&!this.opened&&this.value&&(this._stopPropagation(e),// The clear button is visible and the overlay is closed, so clear the value.
this._clear()):
// Auto-open is enabled
this.opened?(
// The overlay is open
this._stopPropagation(e),this._focusedIndex>-1?(
// An item is focused, revert the input to the filtered value
this._focusedIndex=-1,this._revertInputValue()):
// No item is focused, cancel the change and close the overlay
this.cancel()):this.clearButtonVisible&&this.value&&(this._stopPropagation(e),// The clear button is visible and the overlay is closed, so clear the value.
this._clear())}
/** @private */_toggleElementChanged(e){e&&(
// Don't blur the input on toggle mousedown
e.addEventListener("mousedown",e=>e.preventDefault()),// Unfocus previously focused element if focus is not inside combo box (on touch devices)
e.addEventListener("click",e=>{this.$.overlay.touchDevice&&!this.hasAttribute("focused")&&document.activeElement.blur()}))}
/**
   * Clears the current value.
   * @protected
   */_clear(){this.selectedItem=null,this.allowCustomValue&&(this.value=""),this._detectAndDispatchChange()}
/**
   * Reverts back to original value.
   */cancel(){this._revertInputValueToValue(),// In the next _detectAndDispatchChange() call, the change detection should not pass
this._lastCommittedValue=this.value,this._closeOrCommit()}
/** @private */_onOpened(){
// Pre P2 iron-list used a debouncer to render. Now that we synchronously render items,
// we need to flush the DOM to make sure it doesn't get flushed in the middle of _render call
// because that will cause problems to say the least.
Object(r.b)(),// With iron-list v1.3.9, calling `notifyResize()` no longer renders
// the items synchronously. It is required to have the items rendered
// before we update the overlay and the list positions and sizes.
this.$.overlay.ensureItemsRendered(),this.$.overlay._selector.toggleScrollListener(!0),// Ensure metrics are up-to-date
this.$.overlay.updateViewportBoundaries(),// Force iron-list to create reusable nodes. Otherwise it will only start
// doing that in scroll listener, which is especially slow in Edge.
this.$.overlay._selector._increasePoolIfNeeded(),setTimeout(()=>this._resizeDropdown(),1),// Defer scroll position adjustment to prevent freeze in Edge
window.requestAnimationFrame(()=>this.$.overlay.adjustScrollPosition()),// _detectAndDispatchChange() should not consider value changes done before opening
this._lastCommittedValue=this.value}
/** @private */_onClosed(){
// Happens when the overlay is closed by clicking outside
this.opened&&this.close(),this.loading&&!this.allowCustomValue||this._commitValue()}
/** @private */_commitValue(){if(this.$.overlay._items&&this._focusedIndex>-1){const e=this.$.overlay._items[this._focusedIndex];this.selectedItem!==e&&(this.selectedItem=e),// make sure input field is updated in case value doesn't change (i.e. FOO -> foo)
this._inputElementValue=this._getItemLabel(this.selectedItem)}else if(""===this._inputElementValue||void 0===this._inputElementValue)this.selectedItem=null,this.allowCustomValue&&(this.value="");else{const e=e=>e&&e.toLowerCase&&e.toLowerCase()// Try to find an item whose label matches the input value. A matching item is searched from
// the filteredItems array (if available) and the selectedItem (if available).
,t=[...this.filteredItems||[],this.selectedItem].filter(t=>e(this._getItemLabel(t))===e(this._inputElementValue))[0];if(this.allowCustomValue&&!t){
// An item matching by label was not found, but custom values are allowed.
// Dispatch a custom-value-set event with the input value.
const e=new CustomEvent("custom-value-set",{detail:this._inputElementValue,composed:!0,cancelable:!0,bubbles:!0});if(this.dispatchEvent(e),!e.defaultPrevented){const e=this._inputElementValue;this._selectItemForValue(e),this.value=e}}else this.allowCustomValue||this.opened||!t?
// Revert the input value
this._inputElementValue=this.selectedItem?this._getItemLabel(this.selectedItem):this.value||"":
// An item matching by label was found, select it.
this.value=this._getItemValue(t)}this._detectAndDispatchChange(),this._clearSelectionRange(),this.dataProvider||(this.filter="")}
/**
   * @return {string}
   * @protected
   */get _propertyForValue(){return"value"}
/**
   * Filtering and items handling
   * @param {!Event} e
   * @protected
   */_inputValueChanged(e){
// Handle only input events from our inputElement.
-1!==e.composedPath().indexOf(this.inputElement)&&(this._inputElementValue=this.inputElement[this._propertyForValue],this._filterFromInput(e))}
/** @private */_filterFromInput(e){this.opened||e.__fromClearButton||this.autoOpenDisabled||this.open(),this.filter===this._inputElementValue?
// Filter and input value might get out of sync, while keyboard navigating for example.
// Afterwards, input value might be changed to the same value as used in filtering.
// In situation like these, we need to make sure all the filter changes handlers are run.
this._filterChanged(this.filter,this.itemValuePath,this.itemLabelPath):this.filter=this._inputElementValue}
/** @private */_itemLabelPathChanged(e,t){"string"!=typeof e&&console.error("You should set itemLabelPath to a valid string")}
/** @private */_filterChanged(e,t,i){void 0!==e&&(// Notify the dropdown about filter changing, so to let it skip the
// scrolling restore
this.$.overlay.filterChanged=!0,this.items?this.filteredItems=this._filterItems(this.items,e):
// With certain use cases (e. g., external filtering), `items` are
// undefined. Filtering is unnecessary per se, but the filteredItems
// observer should still be invoked to update focused item.
this._filteredItemsChanged({path:"filteredItems",value:this.filteredItems},t,i))}
/** @private */_loadingChanged(e){e&&(this._focusedIndex=-1)}
/** @protected */_revertInputValue(){""!==this.filter?this._inputElementValue=this.filter:this._revertInputValueToValue(),this._clearSelectionRange()}
/** @private */_revertInputValueToValue(){this.allowCustomValue&&!this.selectedItem?this._inputElementValue=this.value:this._inputElementValue=this._getItemLabel(this.selectedItem)}
/** @private */_resizeDropdown(){this.$.overlay.$.dropdown.notifyResize()}
/** @private */_updateHasValue(e){e?this.setAttribute("has-value",""):this.removeAttribute("has-value")}
/** @private */_selectedItemChanged(e,t){if(null==e)this.filteredItems&&(this.allowCustomValue||(this.value=""),this._updateHasValue(""!==this.value),this._inputElementValue=this.value);else{const t=this._getItemValue(e);if(this.value!==t&&(this.value=t,this.value!==t))
// The value was changed to something else in value-changed listener,
// so prevent from resetting it to the previous value.
return;this._updateHasValue(!0),this._inputElementValue=this._getItemLabel(e),// Could not be defined in 1.x because ready is called after all prop-setters
this.inputElement&&(this.inputElement[this._propertyForValue]=this._inputElementValue)}this.$.overlay._selectedItem=e,this.filteredItems&&this.$.overlay._items&&(this._focusedIndex=this.filteredItems.indexOf(e))}
/** @private */_valueChanged(e,t){if(""!==e||void 0!==t){if(this._isValidValue(e)){let t;this._getItemValue(this.selectedItem)!==e?this._selectItemForValue(e):t=this.selectedItem,!t&&this.allowCustomValue&&(this._inputElementValue=e),this._updateHasValue(""!==this.value)}else this.selectedItem=null;// In the next _detectAndDispatchChange() call, the change detection should pass
this._lastCommittedValue=void 0}}
/** @private */_detectAndDispatchChange(){this.value!==this._lastCommittedValue&&(this.dispatchEvent(new CustomEvent("change",{bubbles:!0})),this._lastCommittedValue=this.value)}
/** @private */_itemsChanged(e,t){this._ensureItemsOrDataProvider(()=>{this.items=t})}
/** @private */_itemsOrPathsChanged(e,t,i){if("items"===e.path||"items.splices"===e.path){this.items?this.filteredItems=this.items.slice(0):this.__previousItems&&(
// Only clear filteredItems if the component had items previously but got cleared
this.filteredItems=null);const e=this._indexOfValue(this.value,this.items);this._focusedIndex=e;const t=e>-1&&this.items[e];t&&(this.selectedItem=t)}this.__previousItems=e.value}
/** @private */_filteredItemsChanged(e,t,i){"filteredItems"!==e.path&&"filteredItems.splices"!==e.path||(this._setOverlayItems(this.filteredItems),this._focusedIndex=this.opened||this.autoOpenDisabled?this.$.overlay.indexOfLabel(this.filter):this._indexOfValue(this.value,this.filteredItems),this.opened&&this._repositionOverlay())}
/** @private */_filterItems(e,t){if(!e)return e;return e.filter(e=>(t=t?t.toString().toLowerCase():"",this._getItemLabel(e).toString().toLowerCase().indexOf(t)>-1))}
/** @private */_selectItemForValue(e){const t=this._indexOfValue(e,this.filteredItems),i=this.selectedItem;this.selectedItem=t>=0?this.filteredItems[t]:this.dataProvider&&void 0===this.selectedItem?void 0:null,null===this.selectedItem&&null===i&&this._selectedItemChanged(this.selectedItem)}
/** @private */_setOverlayItems(e){this.$.overlay.set("_items",e)}
/** @private */_repositionOverlay(){
// async needed to reposition correctly after filtering
// (especially when aligned on top of input)
this.__repositionOverlayDebouncer=s.a.debounce(this.__repositionOverlayDebouncer,// Long debounce: sizing updates invoke multiple styling rounds,
// which is very slow in Edge
o.d.after(500),()=>{const e=this.$.overlay._selector;e._isClientFull()||
// Due to the mismatch of the Y position of the item rendered
// at the top of the scrolling list with some specific scroll
// position values (2324, 3486, 6972, 60972, 95757 etc.)
// iron-list loops the increasing of the pool and adds
// too many items to the DOM.
// Adjusting scroll position to equal the current scrollTop value
// to avoid looping.
e._resetScrollPosition(e._physicalTop),this._resizeDropdown(),this.$.overlay.updateViewportBoundaries(),this.$.overlay.ensureItemsRendered(),e.notifyResize(),Object(r.b)()})}
/** @private */_indexOfValue(e,t){if(t&&this._isValidValue(e))for(let i=0;i<t.length;i++)if(this._getItemValue(t[i])===e)return i;return-1}
/**
   * Checks if the value is supported as an item value in this control.
   * @private
   */_isValidValue(e){return null!=e}
/** @private */_overlaySelectedItemChanged(e){
// stop this private event from leaking outside.
e.stopPropagation(),e.detail.item instanceof h.a||(this.opened?(this._focusedIndex=this.filteredItems.indexOf(e.detail.item),this.close()):this.selectedItem!==e.detail.item&&(this.selectedItem=e.detail.item,this._detectAndDispatchChange()))}
/** @private */_onFocusout(e){
// Fixes the problem with `focusout` happening when clicking on the scroll bar on Edge
const t=this.$.overlay.$.dropdown;t&&t.$&&e.relatedTarget===t.$.overlay?e.composedPath()[0].focus():this.readonly||this._closeOnBlurIsPrevented||this._closeOrCommit()}
/** @private */_onTouchend(e){this._clearElement&&e.composedPath()[0]===this._clearElement&&(e.preventDefault(),this._clear())}
/**
   * Returns true if `value` is valid, and sets the `invalid` flag appropriately.
   *
   * @return {boolean} True if the value is valid and sets the `invalid` flag appropriately
   */validate(){return!(this.invalid=!this.checkValidity())}
/**
   * Returns true if the current input value satisfies all constraints (if any)
   *
   * You can override the `checkValidity` method for custom validations.
   * @return {boolean | undefined}
   */checkValidity(){if(this.inputElement.validate)return this.inputElement.validate()}
/** @private */get _instanceProps(){return{item:!0,index:!0,selected:!0,focused:!0}}
/** @protected */_ensureTemplatized(){if(!this._TemplateClass){const e=this._itemTemplate||this._getRootTemplate();e&&(this._TemplateClass=Object(n.c)(e,this,{instanceProps:this._instanceProps,forwardHostProp:function(e,t){const i=this.$.overlay._selector.querySelectorAll("vaadin-combo-box-item");Array.prototype.forEach.call(i,i=>{i._itemTemplateInstance&&(i._itemTemplateInstance.set(e,t),i._itemTemplateInstance.notifyPath(e,t,!0))})}}))}}
/** @private */_getRootTemplate(){return Array.prototype.filter.call(this.children,e=>"TEMPLATE"===e.tagName)[0]}
/** @protected */_preventInputBlur(){this._toggleElement&&this._toggleElement.addEventListener("click",this._preventDefault),this._clearElement&&this._clearElement.addEventListener("click",this._preventDefault)}
/** @protected */_restoreInputBlur(){this._toggleElement&&this._toggleElement.removeEventListener("click",this._preventDefault),this._clearElement&&this._clearElement.removeEventListener("click",this._preventDefault)}
/** @private */_preventDefault(e){e.preventDefault()}
/**
   * @param {!Event} e
   * @protected
   */_stopPropagation(e){e.stopPropagation()}
/**
   * Fired when the value changes.
   *
   * @event value-changed
   * @param {Object} detail
   *  @param {String} detail.value the combobox value
   */
/**
   * Fired when selected item changes.
   *
   * @event selected-item-changed
   * @param {Object} detail
   *  @param {Object|String} detail.value the selected item. Type is the same as the type of `items`.
   */
/**
   * Fired when the user sets a custom value.
   * @event custom-value-set
   * @param {String} detail the custom value
   */
/**
   * Fired when value changes.
   * To comply with https://developer.mozilla.org/en-US/docs/Web/Events/change
   * @event change
   */}
/***/},
/***/Llpt:
/***/function(e,t,i){"use strict";
// UNUSED EXPORTS: ComboBoxElement
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-combo-box/theme/lumo/vaadin-combo-box-dropdown-styles.js?babel-target=es6
i("w832"),i("82cM"),i("XZNo"),i("zCHs"),i("CThD");
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-combo-box/theme/lumo/vaadin-combo-box-item-styles.js?babel-target=es6
var o=i("o5Wi");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-combo-box/theme/lumo/vaadin-combo-box-styles.js?babel-target=es6
const s=o.a`<dom-module id="lumo-combo-box" theme-for="vaadin-combo-box"><template><style include="lumo-field-button">:host{outline:0}[part=toggle-button]::before{content:var(--lumo-icons-dropdown)}</style></template></dom-module>`;document.head.appendChild(s.content);
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/polymer-element.js?babel-target=es6
var r=i("F3iu"),n=(i("7vYi"),i("6kUO")),a=i("8u2h"),l=i("Giub"),d=(i("a+0f"),i("fRKg")),h=i("OVu0");
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-text-field/src/vaadin-text-field.js?babel-target=es6
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-combo-box/src/vaadin-combo-box.js?babel-target=es6
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * `<vaadin-combo-box>` is a combo box element combining a dropdown list with an
 * input field for filtering the list of items. If you want to replace the default
 * input field with a custom implementation, you should use the
 * [`<vaadin-combo-box-light>`](#/elements/vaadin-combo-box-light) element.
 *
 * Items in the dropdown list must be provided as a list of `String` values.
 * Defining the items is done using the `items` property, which can be assigned
 * with data-binding, using an attribute or directly with the JavaScript property.
 *
 * ```html
 * <vaadin-combo-box
 *     label="Fruit"
 *     items="[[data]]">
 * </vaadin-combo-box>
 * ```
 *
 * ```js
 * combobox.items = ['apple', 'orange', 'banana'];
 * ```
 *
 * When the selected `value` is changed, a `value-changed` event is triggered.
 *
 * This element can be used within an `iron-form`.
 *
 * ### Item rendering
 *
 * `<vaadin-combo-box>` supports using custom renderer callback function for defining the
 * content of `<vaadin-combo-box-item>`.
 *
 * The renderer function provides `root`, `comboBox`, `model` arguments when applicable.
 * Generate DOM content by using `model` object properties if needed, append it to the `root`
 * element and control the state of the host element by accessing `comboBox`. Before generating new
 * content, users are able to check if there is already content in `root` for reusing it.
 *
 * ```html
 * <vaadin-combo-box id="combo-box"></vaadin-combo-box>
 * ```
 * ```js
 * const comboBox = document.querySelector('#combo-box');
 * comboBox.items = [{'label': 'Hydrogen', 'value': 'H'}];
 * comboBox.renderer = function(root, comboBox, model) {
 *   root.innerHTML = model.index + ': ' +
 *                    model.item.label + ' ' +
 *                    '<b>' + model.item.value + '</b>';
 * };
 * ```
 *
 * Renderer is called on the opening of the combo-box and each time the related model is updated.
 * DOM generated during the renderer call can be reused
 * in the next renderer call and will be provided with the `root` argument.
 * On first call it will be empty.
 *
 * ### Item Template
 *
 * Alternatively, the content of the `<vaadin-combo-box-item>` can be populated by using
 * custom item template provided in the light DOM:
 *
 * ```html
 * <vaadin-combo-box items='[{"label": "Hydrogen", "value": "H"}]'>
 *   <template>
 *     [[index]]: [[item.label]] <b>[[item.value]</b>
 *   </template>
 * </vaadin-combo-box>
 * ```
 *
 * The following properties are available for item template bindings:
 *
 * Property name | Type | Description
 * --------------|------|------------
 * `index`| Number | Index of the item in the `items` array
 * `item` | String or Object | The item reference
 * `selected` | Boolean | True when item is selected
 * `focused` | Boolean | True when item is focused
 *
 * ### Lazy Loading with Function Data Provider
 *
 * In addition to assigning an array to the items property, you can alternatively
 * provide the `<vaadin-combo-box>` data through the
 * [`dataProvider`](#/elements/vaadin-combo-box#property-dataProvider) function property.
 * The `<vaadin-combo-box>` calls this function lazily, only when it needs more data
 * to be displayed.
 *
 * See the [`dataProvider`](#/elements/vaadin-combo-box#property-dataProvider) in
 * the API reference below for the detailed data provider arguments description,
 * and the “Lazy Loading“ example on “Basics” page in the demos.
 *
 * __Note that when using function data providers, the total number of items
 * needs to be set manually. The total number of items can be returned
 * in the second argument of the data provider callback:__
 *
 * ```javascript
 * comboBox.dataProvider = function(params, callback) {
 *   var url = 'https://api.example/data' +
 *       '?page=' + params.page +        // the requested page index
 *       '&per_page=' + params.pageSize; // number of items on the page
 *   var xhr = new XMLHttpRequest();
 *   xhr.onload = function() {
 *     var response = JSON.parse(xhr.responseText);
 *     callback(
 *       response.employees, // requested page of items
 *       response.totalSize  // total number of items
 *     );
 *   };
 *   xhr.open('GET', url, true);
 *   xhr.send();
 * };
 * ```
 *
 * ### Styling
 *
 * The following custom properties are available for styling:
 *
 * Custom property | Description | Default
 * ----------------|-------------|-------------
 * `--vaadin-combo-box-overlay-max-height` | Property that determines the max height of overlay | `65vh`
 *
 * The following shadow DOM parts are available for styling:
 *
 * Part name | Description
 * ----------------|----------------
 * `text-field` | The text field
 * `toggle-button` | The toggle button
 *
 * See [`<vaadin-overlay>` documentation](https://github.com/vaadin/vaadin-overlay/blob/master/src/vaadin-overlay.html)
 * for `<vaadin-combo-box-overlay>` parts.
 *
 * See [`<vaadin-text-field>` documentation](https://vaadin.com/components/vaadin-text-field/html-api/elements/Vaadin.TextFieldElement)
 * for the text field parts.
 *
 * The following state attributes are available for styling:
 *
 * Attribute    | Description | Part name
 * -------------|-------------|------------
 * `opened` | Set when the combo box dropdown is open | :host
 * `disabled` | Set to a disabled combo box | :host
 * `readonly` | Set to a read only combo box | :host
 * `has-value` | Set when the element has a value | :host
 * `invalid` | Set when the element is invalid | :host
 * `focused` | Set when the element is focused | :host
 * `focus-ring` | Set when the element is keyboard focused | :host
 * `loading` | Set when new items are expected | :host
 *
 * In addition to `<vaadin-combo-box>` itself, the following internal
 * components are themable:
 *
 * - `<vaadin-text-field>`
 * - `<vaadin-combo-box-overlay>`
 * - `<vaadin-combo-box-item>`
 *
 * Note: the `theme` attribute value set on `<vaadin-combo-box>` is
 * propagated to the internal themable components listed above.
 *
 * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
 *
 * @extends PolymerElement
 * @mixes ElementMixin
 * @mixes ControlStateMixin
 * @mixes ComboBoxDataProviderMixin
 * @mixes ComboBoxMixin
 * @mixes ThemableMixin
 * @demo demo/index.html
 */
class c extends(Object(h.a)(Object(n.a)(Object(a.a)(Object(d.a)(Object(l.a)(r.a)))))){static get template(){return o.a`<style>:host{display:inline-block}:host([hidden]){display:none!important}:host([opened]){pointer-events:auto}[part=text-field]{width:100%;min-width:0}</style><vaadin-text-field part="text-field" id="input" pattern="[[pattern]]" prevent-invalid-input="[[preventInvalidInput]]" value="{{_inputElementValue}}" autocomplete="off" invalid="[[invalid]]" label="[[label]]" name="[[name]]" placeholder="[[placeholder]]" required="[[required]]" disabled="[[disabled]]" readonly="[[readonly]]" helper-text="[[helperText]]" error-message="[[errorMessage]]" autocapitalize="none" autofocus="[[autofocus]]" on-change="_stopPropagation" on-input="_inputValueChanged" clear-button-visible="[[clearButtonVisible]]" theme\$="[[theme]]"><slot name="prefix" slot="prefix"></slot><slot name="helper" slot="helper">[[helperText]]</slot><div part="toggle-button" id="toggleButton" slot="suffix" role="button" aria-label="Toggle"></div></vaadin-text-field><vaadin-combo-box-dropdown-wrapper id="overlay" opened="[[opened]]" renderer="[[renderer]]" position-target="[[_getPositionTarget()]]" _focused-index="[[_focusedIndex]]" _item-id-path="[[itemIdPath]]" _item-label-path="[[itemLabelPath]]" loading="[[loading]]" theme="[[theme]]"></vaadin-combo-box-dropdown-wrapper>`}constructor(){super(),
/**
     * @property
     */
this.theme}static get is(){return"vaadin-combo-box"}static get version(){return"5.4.12"}static get properties(){return{
/**
       * The label for this element.
       */
label:{type:String,reflectToAttribute:!0},
/**
       * Set to true to mark the input as required.
       * @type {boolean}
       */
required:{type:Boolean,value:!1},
/**
       * Set to true to disable this input.
       * @type {boolean}
       */
disabled:{type:Boolean,value:!1},
/**
       * Set to true to prevent the user from entering invalid input.
       * @attr {boolean} prevent-invalid-input
       */
preventInvalidInput:{type:Boolean},
/**
       * A pattern to validate the `input` with.
       */
pattern:{type:String},
/**
       * The error message to display when the input is invalid.
       * @attr {string} error-message
       */
errorMessage:{type:String},
/** @type {boolean} */
autofocus:{type:Boolean},
/**
       * A placeholder string in addition to the label.
       * @type {string}
       */
placeholder:{type:String,value:""},
/**
       * String used for the helper text.
       * @attr {string} helper-text
       */
helperText:{type:String,value:""},
/** @type {boolean} */
readonly:{type:Boolean,value:!1},
/**
       * Set to true to display the clear icon which clears the input.
       * @attr {boolean} clear-button-visible
       * @type {boolean}
       */
clearButtonVisible:{type:Boolean,value:!1}}}static get observers(){return["_updateAriaExpanded(opened)"]}
/**
   * @param {string} name
   * @param {?string} oldValue
   * @param {?string} newValue
   * @protected
   */attributeChangedCallback(e,t,i){super.attributeChangedCallback(e,t,i);/^((?!chrome|android).)*safari/i.test(navigator.userAgent)&&this.root&&Array.prototype.forEach.call(this.root.querySelectorAll("*"),e=>{e.style["-webkit-backface-visibility"]="visible",e.style["-webkit-backface-visibility"]=""})}
/** @protected */ready(){super.ready(),this._nativeInput=this.inputElement.focusElement,this._toggleElement=this.$.toggleButton,this._clearElement=this.inputElement.shadowRoot.querySelector('[part="clear-button"]'),// Stop propagation of Esc in capturing phase so that
// vaadin-text-field will not handle Esc as a shortcut
// to clear the value.
this.addEventListener("keydown",e=>{this._isEventKey(e,"esc")&&
// Trigger _onEscape method of vaadin-combo-box-mixin because
// bubbling phase is not reached.
this._onEscape(e)},!0),this._nativeInput.setAttribute("role","combobox"),this._nativeInput.setAttribute("aria-autocomplete","list"),this._updateAriaExpanded()}
/** @protected */connectedCallback(){super.connectedCallback(),this._preventInputBlur()}
/** @protected */disconnectedCallback(){super.disconnectedCallback(),this._restoreInputBlur()}
/** @private */_getPositionTarget(){return this.$.input}
/** @private */_updateAriaExpanded(){this._nativeInput&&(this._nativeInput.setAttribute("aria-expanded",this.opened),this._toggleElement.setAttribute("aria-expanded",this.opened))}
/** @return {!TextFieldElement | undefined} */get inputElement(){return this.$.input}
/**
   * Focusable element used by vaadin-control-state-mixin
   * @return {!HTMLElement}
   */get focusElement(){
// inputElement might not be defined on property changes before ready.
return this.inputElement||this}}customElements.define(c.is,c)},
/***/"M+Kv":
/***/function(e,t,i){"use strict";
/* harmony import */i("h/KH"),i("70OO"),i("fBRI"),i("y+0W"),i("7L45")
/* harmony import */;const o=i("o5Wi").a`<dom-module id="lumo-button" theme-for="vaadin-button"><template><style>:host{--lumo-button-size:var(--lumo-size-m);min-width:calc(var(--lumo-button-size) * 2);height:var(--lumo-button-size);padding:0 calc(var(--lumo-button-size)/ 3 + var(--lumo-border-radius)/ 2);margin:var(--lumo-space-xs) 0;box-sizing:border-box;font-family:var(--lumo-font-family);font-size:var(--lumo-font-size-m);font-weight:500;color:var(--_lumo-button-color,var(--lumo-primary-text-color));background-color:var(--_lumo-button-background-color,var(--lumo-contrast-5pct));border-radius:var(--lumo-border-radius);cursor:default;-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}[part=label],[part=prefix],[part=suffix]{line-height:var(--lumo-line-height-xs)}[part=label]{padding:calc(var(--lumo-button-size)/ 6) 0}:host([theme~=small]){font-size:var(--lumo-font-size-s);--lumo-button-size:var(--lumo-size-s)}:host([theme~=large]){font-size:var(--lumo-font-size-l);--lumo-button-size:var(--lumo-size-l)}:host([disabled][disabled]){pointer-events:none;color:var(--lumo-disabled-text-color);background-color:var(--lumo-contrast-5pct)}:host::after,:host::before{content:"";position:absolute;z-index:1;top:0;right:0;bottom:0;left:0;background-color:currentColor;border-radius:inherit;opacity:0;transition:opacity .2s;pointer-events:none}:host(:hover)::before{opacity:.05}@media (pointer:coarse){:host(:not([active]):hover)::before{opacity:0}}:host::after{transition:opacity 1.4s,transform .1s;filter:blur(8px)}:host([active])::before{opacity:.1;transition-duration:0s}:host([active])::after{opacity:.1;transition-duration:0s,0s;transform:scale(0)}:host([focus-ring]){box-shadow:0 0 0 2px var(--lumo-primary-color-50pct)}:host([theme~=tertiary-inline]),:host([theme~=tertiary]){background-color:transparent!important;transition:opacity .2s;min-width:0}:host([theme~=tertiary-inline])::before,:host([theme~=tertiary])::before{display:none}:host([theme~=tertiary]){padding:0 calc(var(--lumo-button-size)/ 6)}@media (hover:hover){:host([theme*=tertiary]:not([active]):hover){opacity:.8}}:host([theme~=tertiary-inline][active]),:host([theme~=tertiary][active]){opacity:.5;transition-duration:0s}:host([theme~=tertiary-inline]){margin:0;height:auto;padding:0;line-height:inherit;font-size:inherit}:host([theme~=tertiary-inline]) [part=label]{padding:0;overflow:visible;line-height:inherit}:host([theme~=primary]){background-color:var(--_lumo-button-primary-background-color,var(--lumo-primary-color));color:var(--_lumo-button-primary-color,var(--lumo-primary-contrast-color));font-weight:600;min-width:calc(var(--lumo-button-size) * 2.5)}:host([theme~=primary][disabled]){background-color:var(--lumo-primary-color-50pct);color:var(--lumo-primary-contrast-color)}:host([theme~=primary]:hover)::before{opacity:.1}:host([theme~=primary][active])::before{background-color:var(--lumo-shade-20pct)}@media (pointer:coarse){:host([theme~=primary][active])::before{background-color:var(--lumo-shade-60pct)}:host([theme~=primary]:not([active]):hover)::before{opacity:0}}:host([theme~=primary][active])::after{opacity:.2}:host([theme~=success]){color:var(--lumo-success-text-color)}:host([theme~=success][theme~=primary]){background-color:var(--lumo-success-color);color:var(--lumo-success-contrast-color)}:host([theme~=success][theme~=primary][disabled]){background-color:var(--lumo-success-color-50pct)}:host([theme~=error]){color:var(--lumo-error-text-color)}:host([theme~=error][theme~=primary]){background-color:var(--lumo-error-color);color:var(--lumo-error-contrast-color)}:host([theme~=error][theme~=primary][disabled]){background-color:var(--lumo-error-color-50pct)}:host([theme~=contrast]){color:var(--lumo-contrast)}:host([theme~=contrast][theme~=primary]){background-color:var(--lumo-contrast);color:var(--lumo-base-color)}:host([theme~=contrast][theme~=primary][disabled]){background-color:var(--lumo-contrast-50pct)}[part] ::slotted(iron-icon){display:inline-block;width:var(--lumo-icon-size-m);height:var(--lumo-icon-size-m)}[part] ::slotted(iron-icon[icon^="vaadin:"]){padding:.25em;box-sizing:border-box!important}[part=prefix]{margin-left:-.25em;margin-right:.25em}[part=suffix]{margin-left:.25em;margin-right:-.25em}:host([theme~=icon]:not([theme~=tertiary-inline])){min-width:var(--lumo-button-size);padding-left:calc(var(--lumo-button-size)/ 4);padding-right:calc(var(--lumo-button-size)/ 4)}:host([theme~=icon]) [part=prefix],:host([theme~=icon]) [part=suffix]{margin-left:0;margin-right:0}:host([dir=rtl]) [part=prefix]{margin-left:.25em;margin-right:-.25em}:host([dir=rtl]) [part=suffix]{margin-left:-.25em;margin-right:.25em}:host([dir=rtl][theme~=icon]) [part=prefix],:host([dir=rtl][theme~=icon]) [part=suffix]{margin-left:0;margin-right:0}</style></template></dom-module>`;document.head.appendChild(o.content)},
/***/MKwm:
/***/function(e,t,i){"use strict";
/* harmony import */i("EgM/"),i("lFcJ")
/* harmony import */},
/***/Yz1v:
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return o}));
/**
@license
Copyright (c) 2018 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/*
 * Placeholder object class representing items being loaded.
 *
 * @private
 */
const o=class{toString(){return""}};
/***/},
/***/"a+0f":
/***/function(e,t,i){"use strict";
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/polymer-element.js?babel-target=es6
var o=i("F3iu"),s=(i("kpqP"),i("8u2h")),r=i("ZWVL"),n=i("o5Wi");
// EXTERNAL MODULE: ./node_modules/@polymer/iron-list/iron-list.js?babel-target=es6
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-combo-box/src/vaadin-combo-box-item.js?babel-target=es6
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * The default element used for items in the vaadin-combo-box.
 *
 * ### Styling
 *
 * The following shadow DOM parts are available for styling:
 *
 * Part name | Description
 * ---|---
 * `content` | The element that wraps the item label or template content
 *
 * The following state attributes are exposed for styling:
 *
 * Attribute    | Description | Part name
 * -------------|-------------|------------
 * `selected` | Set when the item is selected | :host
 * `focused` | Set when the item is focused | :host
 *
 * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
 *
 * @extends PolymerElement
 * @mixes ThemableMixin
 * @private
 */
class a extends(Object(s.a)(Object(r.a)(o.a))){static get template(){return n.a`<style>:host{display:block}:host([hidden]){display:none}</style><div part="content" id="content"></div>`}static get is(){return"vaadin-combo-box-item"}static get properties(){return{
/**
       * The index of the item
       */
index:Number,
/**
       * The item to render
       * @type {(String|Object)}
       */
item:Object,
/**
       * The text label corresponding to the item
       */
label:String,
/**
       * True when item is selected
       */
selected:{type:Boolean,value:!1,reflectToAttribute:!0},
/**
       * True when item is focused
       */
focused:{type:Boolean,value:!1,reflectToAttribute:!0},
/**
       * The template instance corresponding to the item
       */
_itemTemplateInstance:Object,
/**
       * Custom function for rendering the content of the `<vaadin-combo-box-item>` propagated from the combo box element.
       */
renderer:Function,
/**
       * Saved instance of a custom renderer function.
       */
_oldRenderer:Function}}static get observers(){return["_rendererOrItemChanged(renderer, index, item.*)","_updateLabel(label, _itemTemplateInstance)",'_updateTemplateInstanceVariable("index", index, _itemTemplateInstance)','_updateTemplateInstanceVariable("item", item, _itemTemplateInstance)','_updateTemplateInstanceVariable("selected", selected, _itemTemplateInstance)','_updateTemplateInstanceVariable("focused", focused, _itemTemplateInstance)']}connectedCallback(){if(super.connectedCallback(),!this._itemTemplateInstance){
// 2.0 has __dataHost. Might want to consider assigning combobox reference directly to item.
const e=this.getRootNode().host.getRootNode().host.__dataHost.getRootNode().host;this._comboBox=e.getRootNode().host,this._comboBox._ensureTemplatized(),this._comboBox._TemplateClass&&(this._itemTemplateInstance=new this._comboBox._TemplateClass({}),this.$.content.textContent="",this.$.content.appendChild(this._itemTemplateInstance.root))}const e=this._comboBox.getAttribute("dir");e&&this.setAttribute("dir",e)}_render(){if(!this.renderer)return;const e={index:this.index,item:this.item};this.renderer(this.$.content,this._comboBox,e)}_rendererOrItemChanged(e,t,i){void 0!==i&&void 0!==t&&(this._oldRenderer!==e&&(this.$.content.innerHTML=""),e&&(this._oldRenderer=e,this._render()))}_updateLabel(e,t){void 0===t&&this.$.content&&!this.renderer&&(
// Only set label to textContent no template
this.$.content.textContent=e)}_updateTemplateInstanceVariable(e,t,i){void 0!==e&&void 0!==t&&void 0!==i&&(i[e]=t)}}customElements.define(a.is,a);
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/lib/mixins/disable-upgrade-mixin.js?babel-target=es6
var l=i("pczb"),d=i("85Oo"),h=i("JxY1"),c=i("x3pe");
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-overlay/src/vaadin-overlay.js?babel-target=es6 + 1 modules
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-combo-box/src/vaadin-combo-box-dropdown.js?babel-target=es6
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
const u=document.createElement("template");let m;
/**
 * The overlay element.
 *
 * ### Styling
 *
 * See [`<vaadin-overlay>` documentation](https://github.com/vaadin/vaadin-overlay/blob/master/src/vaadin-overlay.html)
 * for `<vaadin-combo-box-overlay>` parts.
 *
 * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
 *
 * @extends PolymerElement
 * @private
 */u.innerHTML='<dom-module id="vaadin-combo-box-overlay-styles" theme-for="vaadin-combo-box-overlay"><template><style>:host { width: var(--vaadin-combo-box-overlay-width, var(--_vaadin-combo-box-overlay-default-width, auto)); }</style></template></dom-module>',document.head.appendChild(u.content);class p extends d.a{static get is(){return"vaadin-combo-box-overlay"}static get properties(){return{
/**
       * The element to position/align the dropdown by.
       */
positionTarget:{type:Object}}}static get template(){return m||(m=super.template.cloneNode(!0),m.content.querySelector('[part~="overlay"]').removeAttribute("tabindex")),m}connectedCallback(){super.connectedCallback();const e=this.__dataHost.getRootNode().host,t=e&&e.getRootNode().host,i=t&&t.getAttribute("dir");i&&this.setAttribute("dir",i)}ready(){super.ready();const e=document.createElement("div");e.setAttribute("part","loader");const t=this.shadowRoot.querySelector('[part~="content"]');t.parentNode.insertBefore(e,t)}
/**
   * Override OverlayElement._outsideClickListener to prevent closing the
   * overlay when clicking into the combo box input element
   * @param event
   * @private
   */_outsideClickListener(e){const t=e.composedPath();t.indexOf(this.positionTarget)<0&&t.indexOf(this)<0&&this.close()}}customElements.define(p.is,p);
/**
 * Element for internal use only.
 *
 * @extends PolymerElement
 * @private
 */
class _ extends(Object(l.a)(Object(c.b)(h.a,o.a))){static get template(){return n.a`<style>:host{display:block}:host>#overlay{display:none}</style><vaadin-combo-box-overlay id="overlay" hidden\$="[[hidden]]" position-target="[[positionTarget]]" opened="{{opened}}" template="{{template}}" style="align-items:stretch;margin:0" theme\$="[[theme]]"><slot></slot></vaadin-combo-box-overlay>`}static get is(){return"vaadin-combo-box-dropdown"}static get properties(){return{opened:{type:Boolean,observer:"_openedChanged"},template:{type:Object,notify:!0},
/**
       * The element to position/align the dropdown by.
       */
positionTarget:{type:Object},
/**
       * If `true`, overlay is aligned above the `positionTarget`
       */
alignedAbove:{type:Boolean,value:!1},
/**
       * Used to propagate the `theme` attribute from the host element.
       */
theme:String}}constructor(){super(),this._boundSetPosition=this._setPosition.bind(this)}connectedCallback(){super.connectedCallback(),this.addEventListener("iron-resize",this._boundSetPosition)}ready(){super.ready(),// Preventing the default modal behaviour of the overlay on input clicking
this.$.overlay.addEventListener("vaadin-overlay-outside-click",e=>{e.preventDefault()})}disconnectedCallback(){super.disconnectedCallback(),this.removeEventListener("iron-resize",this._boundSetPosition),// Making sure the overlay is closed and removed from DOM after detaching the dropdown.
this.opened=!1}notifyResize(){super.notifyResize(),this.positionTarget&&this.opened&&(this._setPosition(),// Schedule another position update (to cover virtual keyboard opening for example)
requestAnimationFrame(this._setPosition.bind(this)))}
/**
   * Fired after the `vaadin-combo-box-dropdown` opens.
   *
   * @event vaadin-combo-box-dropdown-opened
   */
/**
   * Fired after the `vaadin-combo-box-dropdown` closes.
   *
   * @event vaadin-combo-box-dropdown-closed
   */_openedChanged(e,t){!!e!=!!t&&(e?(this.$.overlay.style.position=this._isPositionFixed(this.positionTarget)?"fixed":"absolute",this._setPosition(),window.addEventListener("scroll",this._boundSetPosition,!0),this.dispatchEvent(new CustomEvent("vaadin-combo-box-dropdown-opened",{bubbles:!0,composed:!0}))):this.__emptyItems||(window.removeEventListener("scroll",this._boundSetPosition,!0),this.dispatchEvent(new CustomEvent("vaadin-combo-box-dropdown-closed",{bubbles:!0,composed:!0}))))}_isPositionFixed(e){const t=this._getOffsetParent(e);return"fixed"===window.getComputedStyle(e).position||t&&this._isPositionFixed(t)}_getOffsetParent(e){if(e.assignedSlot)return e.assignedSlot.parentElement;if(e.parentElement)return e.offsetParent;const t=e.parentNode;return t&&11===t.nodeType&&t.host?t.host:void 0}_verticalOffset(e,t){return this.alignedAbove?-e.height:t.height}_shouldAlignAbove(e){return(window.innerHeight-e.bottom-Math.min(document.body.scrollTop,0))/window.innerHeight<.3}_getCustomWidth(){return window.ShadyCSS?window.ShadyCSS.getComputedStyleValue(this,"--vaadin-combo-box-overlay-width"):getComputedStyle(this).getPropertyValue("--vaadin-combo-box-overlay-width")}_setOverlayWidth(){const e=this.positionTarget.clientWidth+"px",t=this._getCustomWidth();window.ShadyCSS&&!window.ShadyCSS.nativeCss?window.ShadyCSS.styleSubtree(this.$.overlay,{"--vaadin-combo-box-overlay-width":t,"--_vaadin-combo-box-overlay-default-width":e}):(this.$.overlay.style.setProperty("--_vaadin-combo-box-overlay-default-width",e),""===t?this.$.overlay.style.removeProperty("--vaadin-combo-box-overlay-width"):this.$.overlay.style.setProperty("--vaadin-combo-box-overlay-width",t))}_setPosition(e){if(this.hidden)return;if(e&&e.target){const t=e.target===document?document.body:e.target,i=this.$.overlay.parentElement;if(!t.contains(this.$.overlay)&&!t.contains(this.positionTarget)||i!==document.body)return}const t=this.positionTarget.getBoundingClientRect();this.alignedAbove=this._shouldAlignAbove(t);const i=this.$.overlay.getBoundingClientRect();this._translateX=t.left-i.left+(this._translateX||0),this._translateY=t.top-i.top+(this._translateY||0)+this._verticalOffset(i,t);const o=window.devicePixelRatio||1;this._translateX=Math.round(this._translateX*o)/o,this._translateY=Math.round(this._translateY*o)/o,this.$.overlay.style.transform=`translate3d(${this._translateX}px, ${this._translateY}px, 0)`,this.$.overlay.style.justifyContent=this.alignedAbove?"flex-end":"flex-start",this._setOverlayWidth(),// TODO: fire only when position actually changes changes
this.dispatchEvent(new CustomEvent("position-changed"))}}customElements.define(_.is,_);
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-combo-box/src/vaadin-combo-box-placeholder.js?babel-target=es6
var b=i("Yz1v");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-combo-box/src/vaadin-combo-box-dropdown-wrapper.js?babel-target=es6
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/const v=(()=>{try{return document.createEvent("TouchEvent"),!0}catch(e){return!1}})();
/**
 * Element for internal use only.
 *
 * @extends PolymerElement
 * @private
 */class g extends class extends o.a{}{static get template(){return n.a`<vaadin-combo-box-dropdown id="dropdown" hidden="[[_hidden(_items.*, loading)]]" position-target="[[positionTarget]]" on-template-changed="_templateChanged" on-position-changed="_setOverlayHeight" disable-upgrade="" theme="[[theme]]"><template><style>#scroller{overflow:auto;transform:translate3d(0,0,0);-webkit-overflow-scrolling:touch;box-shadow:0 0 0 #fff}</style><div id="scroller" on-click="_stopPropagation"><iron-list id="selector" role="listbox" items="[[_getItems(opened, _items)]]" scroll-target="[[_scroller]]"><template><vaadin-combo-box-item on-click="_onItemClick" index="[[__requestItemByIndex(item, index, _resetScrolling)]]" item="[[item]]" label="[[getItemLabel(item, _itemLabelPath)]]" selected="[[_isItemSelected(item, _selectedItem, _itemIdPath)]]" renderer="[[renderer]]" role\$="[[_getAriaRole(index)]]" aria-selected\$="[[_getAriaSelected(_focusedIndex,index)]]" focused="[[_isItemFocused(_focusedIndex,index)]]" tabindex="-1" theme\$="[[theme]]"></vaadin-combo-box-item></template></iron-list></div></template></vaadin-combo-box-dropdown>`}static get is(){return"vaadin-combo-box-dropdown-wrapper"}static get properties(){return{
/**
       * True if the device supports touch events.
       */
touchDevice:{type:Boolean,value:v},opened:Boolean,
/**
       * The element to position/align the dropdown by.
       */
positionTarget:{type:Object},
/**
       * Custom function for rendering the content of the `<vaadin-combo-box-item>` propagated from the combo box element.
       */
renderer:Function,
/**
       * `true` when new items are being loaded.
       */
loading:{type:Boolean,value:!1,reflectToAttribute:!0,observer:"_setOverlayHeight"},
/**
       * Used to propagate the `theme` attribute from the host element.
       */
theme:String,
/**
       * Used to recognize if the filter changed, so to skip the
       * scrolling restore. If true, then scroll to 0 position. Restore
       * the previous position otherwise.
       */
filterChanged:{type:Boolean,value:!1},
/**
       * Used to recognize scroller reset after new items have been set
       * to iron-list and to ignore unwanted pages load. If 'true', then
       * skip loading of the pages until it becomes 'false'.
       */
_resetScrolling:{type:Boolean,value:!1},_selectedItem:{type:Object},_items:{type:Object},_focusedIndex:{type:Number,value:-1,observer:"_focusedIndexChanged"},_focusedItem:{type:String,computed:"_getFocusedItem(_focusedIndex)"},_itemLabelPath:{type:String,value:"label"},_itemValuePath:{type:String,value:"value"},_selector:Object,_itemIdPath:String,
/**
       * Stores the scroller position before updating the 'items', in
       * order to restore it immediately after 'items' have been updated
       */
_oldScrollerPosition:{type:Number,value:0}}}static get observers(){return["_selectorChanged(_selector)","_loadingChanged(loading)","_openedChanged(opened, _items, loading)","_restoreScrollerPosition(_items)"]}_fireTouchAction(e){this.dispatchEvent(new CustomEvent("vaadin-overlay-touch-action",{detail:{sourceEvent:e}}))}_getItems(e,t){if(e){if(this._isNotEmpty(t)&&this._selector&&!this.filterChanged){
// iron-list triggers the scroller's reset after items update, and
// this is not appropriate for undefined size lazy loading.
// see https://github.com/vaadin/vaadin-combo-box-flow/issues/386
// We store iron-list scrolling position in order to restore
// it later on after the items have been updated.
const e=this._selector.firstVisibleIndex;0!==e&&(this._oldScrollerPosition=e,this._resetScrolling=!0)}// Let the position to be restored in the future calls unless it's not
// caused by filtering
return this.filterChanged=!1,t}return[]}_restoreScrollerPosition(e){this._isNotEmpty(e)&&this._selector&&0!==this._oldScrollerPosition&&(
// new items size might be less than old scrolling position
this._scrollIntoView(Math.min(e.length-1,this._oldScrollerPosition)),this._resetScrolling=!1,// reset position to 0 again in order to properly handle the filter
// cases (scroll to 0 after typing the filter)
this._oldScrollerPosition=0)}_isNotEmpty(e){return!this._isEmpty(e)}_isEmpty(e){return!e||!e.length}_openedChanged(e,t,i){if(this.$.dropdown.hasAttribute("disable-upgrade")){if(!e)return;this._initDropdown()}this._isEmpty(t)&&(this.$.dropdown.__emptyItems=!0),this.$.dropdown.opened=!(!e||!i&&!this._isNotEmpty(t)),this.$.dropdown.__emptyItems=!1}_initDropdown(){this.$.dropdown.removeAttribute("disable-upgrade"),this._templateChanged(),this._loadingChanged(this.loading),this.$.dropdown.$.overlay.addEventListener("touchend",e=>this._fireTouchAction(e)),this.$.dropdown.$.overlay.addEventListener("touchmove",e=>this._fireTouchAction(e)),// Prevent blurring the input when clicking inside the overlay.
this.$.dropdown.$.overlay.addEventListener("mousedown",e=>e.preventDefault()),// IE11: when scrolling with mouse, the focus goes to the scroller.
// This causes the overlay closing due to defocusing the input field.
// Prevent focusing the scroller by setting `unselectable="on"`.
/Trident/.test(navigator.userAgent)&&this._scroller.setAttribute("unselectable","on")}_templateChanged(e){this.$.dropdown.hasAttribute("disable-upgrade")||(this._selector=this.$.dropdown.$.overlay.content.querySelector("#selector"),this._scroller=this.$.dropdown.$.overlay.content.querySelector("#scroller"))}_loadingChanged(e){this.$.dropdown.hasAttribute("disable-upgrade")||(e?this.$.dropdown.$.overlay.setAttribute("loading",""):this.$.dropdown.$.overlay.removeAttribute("loading"))}_selectorChanged(e){this._patchWheelOverScrolling()}_setOverlayHeight(){if(!this.opened||!this.positionTarget||!this._selector)return;const e=this.positionTarget.getBoundingClientRect();this._scroller.style.maxHeight=(window.ShadyCSS?window.ShadyCSS.getComputedStyleValue(this,"--vaadin-combo-box-overlay-max-height"):getComputedStyle(this).getPropertyValue("--vaadin-combo-box-overlay-max-height"))||"65vh";const t=this._maxOverlayHeight(e);// overlay max height is restrained by the #scroller max height which is set to 65vh in CSS.
this.$.dropdown.$.overlay.style.maxHeight=t,// we need to set height for iron-list to make its `firstVisibleIndex` work correctly.
this._selector.style.maxHeight=t,this.updateViewportBoundaries()}_maxOverlayHeight(e){// Height of two items in combo-box
return this.$.dropdown.alignedAbove?Math.max(e.top-8+Math.min(document.body.scrollTop,0),116)+"px":Math.max(document.documentElement.clientHeight-e.bottom-8,116)+"px"}_getFocusedItem(e){if(e>=0)return this._items[e]}_isItemSelected(e,t,i){return!(e instanceof b.a)&&(i&&void 0!==e&&void 0!==t?this.get(i,e)===this.get(i,t):e===t)}_onItemClick(e){e.detail&&e.detail.sourceEvent&&e.detail.sourceEvent.stopPropagation&&this._stopPropagation(e.detail.sourceEvent),this.dispatchEvent(new CustomEvent("selection-changed",{detail:{item:e.model.item}}))}
/**
   * Gets the index of the item with the provided label.
   * @return {number}
   */indexOfLabel(e){if(this._items&&e)for(let t=0;t<this._items.length;t++)if(this.getItemLabel(this._items[t]).toString().toLowerCase()===e.toString().toLowerCase())return t;return-1}
/**
   * If dataProvider is used, dispatch a request for the item’s index if
   * the item is a placeholder object.
   *
   * @return {number}
   */__requestItemByIndex(e,t,i){return e instanceof b.a&&void 0!==t&&!i&&this.dispatchEvent(new CustomEvent("index-requested",{detail:{index:t,currentScrollerPos:this._oldScrollerPosition}})),t}
/**
   * Gets the label string for the item based on the `_itemLabelPath`.
   * @return {string}
   */getItemLabel(e,t){t=t||this._itemLabelPath;let i=e&&t?this.get(t,e):void 0;return null==i&&(i=e?e.toString():""),i}_isItemFocused(e,t){return e==t}_getAriaSelected(e,t){return this._isItemFocused(e,t).toString()}_getAriaRole(e){return void 0!==e&&"option"}_focusedIndexChanged(e){e>=0&&this._scrollIntoView(e)}_scrollIntoView(e){if(!(this.opened&&e>=0))return;const t=this._visibleItemsCount();if(void 0===t)
// Scroller is not visible. Moving is unnecessary.
return;let i=e;e>this._selector.lastVisibleIndex-1?(
// Index is below the bottom, scrolling down. Make the item appear at the bottom.
// First scroll to target (will be at the top of the scroller) to make sure it's rendered.
this._selector.scrollToIndex(e),// Then calculate the index for the following scroll (to get the target to bottom of the scroller).
i=e-t+1):e>this._selector.firstVisibleIndex&&(
// The item is already visible, scrolling is unnecessary per se. But we need to trigger iron-list to set
// the correct scrollTop on the scrollTarget. Scrolling to firstVisibleIndex.
i=this._selector.firstVisibleIndex),this._selector.scrollToIndex(Math.max(0,i));// Sometimes the item is partly below the bottom edge, detect and adjust.
const o=this._selector._getPhysicalIndex(e),s=this._selector._physicalItems[o];if(!s)return;const r=s.getBoundingClientRect(),n=this._scroller.getBoundingClientRect(),a=r.bottom-n.bottom+this._viewportTotalPaddingBottom;a>0&&(this._scroller.scrollTop+=a)}ensureItemsRendered(){this._selector._render()}adjustScrollPosition(){this.opened&&this._items&&this._scrollIntoView(this._focusedIndex)}
/**
   * We want to prevent the kinetic scrolling energy from being transferred from the overlay contents over to the parent.
   * Further improvement ideas: after the contents have been scrolled to the top or bottom and scrolling has stopped, it could allow
   * scrolling the parent similarly to touch scrolling.
   */_patchWheelOverScrolling(){const e=this._selector;e.addEventListener("wheel",t=>{const i=e._scroller||e.scrollTarget,o=0===i.scrollTop,s=i.scrollHeight-i.scrollTop-i.clientHeight<=1;(o&&t.deltaY<0||s&&t.deltaY>0)&&t.preventDefault()})}updateViewportBoundaries(){this._cachedViewportTotalPaddingBottom=void 0,this._selector.updateViewportBoundaries()}get _viewportTotalPaddingBottom(){if(void 0===this._cachedViewportTotalPaddingBottom){const e=window.getComputedStyle(this._selector.$.items);this._cachedViewportTotalPaddingBottom=[e.paddingBottom,e.borderBottomWidth].map(e=>parseInt(e,10)).reduce((e,t)=>e+t)}return this._cachedViewportTotalPaddingBottom}_visibleItemsCount(){if(this._selector)// Ensure items are rendered
return this._selector.flushDebouncer("_debounceTemplate"),// Ensure items are positioned
this._selector.scrollToIndex(this._selector.firstVisibleIndex),// Ensure viewport boundaries are up-to-date
this.updateViewportBoundaries(),this._selector.lastVisibleIndex-this._selector.firstVisibleIndex+1}_selectItem(e){e="number"==typeof e?this._items[e]:e,this._selector.selectedItem!==e&&this._selector.selectItem(e)}_preventDefault(e){e.cancelable&&e.preventDefault()}_stopPropagation(e){e.stopPropagation()}_hidden(e){return!this.loading&&this._isEmpty(this._items)}}customElements.define(g.is,g)},
/***/dRsS:
/***/function(e,t,i){"use strict";
// UNUSED EXPORTS: AccordionElement
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-lumo-styles/color.js?babel-target=es6
i("h/KH"),i("fBRI"),i("Aa+d");
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-lumo-styles/spacing.js?babel-target=es6
var o=i("o5Wi");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-accordion/theme/lumo/vaadin-accordion-panel-styles.js?babel-target=es6
const s=o.a`<dom-module id="lumo-accordion-panel" theme-for="vaadin-accordion-panel"><template><style include="lumo-details">:host{margin:0;border-bottom:solid 1px var(--lumo-contrast-10pct)}:host(:last-child){border-bottom:none}:host([theme~=filled]){border-bottom:none}:host([theme~=filled]:not(:last-child)){margin-bottom:2px}</style></template></dom-module>`;document.head.appendChild(s.content);
// EXTERNAL MODULE: ./node_modules/@vaadin/vaadin-details/src/vaadin-details.js?babel-target=es6
var r=i("6y5i");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-accordion/src/vaadin-accordion-panel.js?babel-target=es6
/**
@license
Copyright (c) 2018 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * The accordion panel element.
 *
 * ### Styling
 *
 * The following shadow DOM parts are exposed for styling:
 *
 * Part name        | Description
 * -----------------|----------------
 * `summary`        | The element used to open and close collapsible content.
 * `toggle`         | The element used as indicator, can represent an icon.
 * `summary-content`| The wrapper for the slotted summary content.
 * `content`        | The wrapper for the collapsible panel content.
 *
 * The following attributes are exposed for styling:
 *
 * Attribute    | Description
 * -------------| -----------
 * `opened`     | Set when the collapsible content is expanded and visible.
 * `disabled`   | Set when the element is disabled.
 * `focus-ring` | Set when the element is focused using the keyboard.
 * `focused`    | Set when the element is focused.
 *
 * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
 *
 */class n extends r.a{static get is(){return"vaadin-accordion-panel"}}customElements.define(n.is,n);
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-accordion/theme/lumo/vaadin-accordion-panel.js?babel-target=es6
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/polymer-element.js?babel-target=es6
var a=i("F3iu"),l=i("6hLg"),d=i("OVu0"),h=i("8u2h");
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/lib/utils/flattened-nodes-observer.js?babel-target=es6
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-accordion/src/vaadin-accordion.js?babel-target=es6
/**
@license
Copyright (c) 2018 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * `<vaadin-accordion>` is a Web Component implementing accordion widget —
 * a vertically stacked set of expandable panels. The component should be
 * used as a wrapper for two or more `<vaadin-accordion-panel>` components.
 *
 * Panel headings function as controls that enable users to open (expand)
 * or hide (collapse) their associated sections of content. The user can
 * toggle panels by mouse click, Enter and Space keys.
 *
 * Only one panel can be opened at a time, opening a new one forces
 * previous panel to close and hide its content.
 *
 * ```
 * <vaadin-accordion>
 *   <vaadin-accordion-panel>
 *     <div slot="summary">Panel 1</div>
 *     This panel is opened, so the text is visible by default.
 *   </vaadin-accordion-panel>
 *   <vaadin-accordion-panel>
 *     <div slot="summary">Panel 2</div>
 *     After opening this panel, the first one becomes closed.
 *   </vaadin-accordion-panel>
 * </vaadin-accordion>
 * ```
 *
 * ### Styling
 *
 * See the [`<vaadin-accordion-panel>`](#/elements/vaadin-accordion-panel)
 * documentation for the available state attributes and stylable shadow parts.
 *
 * **Note:** You can apply the theme to `<vaadin-accordion>` component itself,
 * especially by using the following CSS selector:
 *
 * ```
 * :host ::slotted(vaadin-accordion-panel) {
 *   margin-bottom: 5px;
 * }
 * ```
 *
 * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
 *
 * @extends PolymerElement
 * @mixes ElementMixin
 * @mixes ThemableMixin
 * @demo demo/index.html
 */
class c extends(Object(h.a)(Object(d.a)(a.a))){static get template(){return o.a`<style>:host{display:block}:host([hidden]){display:none!important}</style><slot></slot>`}static get is(){return"vaadin-accordion"}static get version(){return"1.2.0"}static get properties(){return{
/**
       * The index of currently opened panel. First panel is opened by
       * default. Only one panel can be opened at the same time.
       * Setting null or undefined closes all the accordion panels.
       * @type {number}
       */
opened:{type:Number,value:0,notify:!0,reflectToAttribute:!0},
/**
       * The list of `<vaadin-accordion-panel>` child elements.
       * It is populated from the elements passed to the light DOM,
       * and updated dynamically when adding or removing panels.
       * @type {!Array<!AccordionPanelElement>}
       */
items:{type:Array,readOnly:!0,notify:!0}}}static get observers(){return["_updateItems(items, opened)"]}constructor(){super(),this._boundUpdateOpened=this._updateOpened.bind(this)}
/**
   * @return {Element | null}
   * @protected
   */get focused(){return this.getRootNode().activeElement}
/**
   * @protected
   */focus(){this._observer&&this._observer.flush();const e=Array.isArray(this.items)&&this.items[0];e&&e.focus()}ready(){super.ready(),this.addEventListener("keydown",e=>this._onKeydown(e)),this._observer=new l.a(this,e=>{this._setItems(this._filterItems(Array.from(this.children))),this._filterItems(e.addedNodes).forEach(e=>{e.addEventListener("opened-changed",this._boundUpdateOpened)})})}
/**
   * @param {!Array<!Element>} array
   * @return {!Array<!AccordionPanelElement>}
   * @protected
   */_filterItems(e){return e.filter(e=>e instanceof n)}
/** @private */_updateItems(e,t){if(e){const i=e[t];e.forEach(e=>{e.opened=e===i})}}
/**
   * @param {!KeyboardEvent} event
   * @protected
   */_onKeydown(e){
// only check keyboard events on details toggle buttons
const t=e.composedPath()[0];if(!this.items.some(e=>e.focusElement===t))return;// IE names for arrows do not include the Arrow prefix
const i=e.key.replace(/^Arrow/,""),o=this.items.indexOf(this.focused);let s,r;switch(i){case"Up":r=-1,s=o-1;break;case"Down":r=1,s=o+1;break;case"Home":r=1,s=0;break;case"End":r=-1,s=this.items.length-1}s=this._getAvailableIndex(s,r),s>=0&&(this.items[s].focus(),this.items[s].setAttribute("focus-ring",""),e.preventDefault())}
/**
   * @param {number} index
   * @param {number} increment
   * @return {number}
   * @protected
   */_getAvailableIndex(e,t){const i=this.items.length;let o=e;for(let e=0;"number"==typeof o&&e<i;e++,o+=t||1){o<0?o=i-1:o>=i&&(o=0);if(!this.items[o].disabled)return o}return-1}
/** @private */_updateOpened(e){const t=this._filterItems(e.composedPath())[0],i=this.items.indexOf(t);if(e.detail.value){if(t.disabled||-1===i)return;this.opened=i,this.items.forEach(e=>{e!==t&&e.opened&&(e.opened=!1)})}else this.items.some(e=>e.opened)||(this.opened=null)}}customElements.define(c.is,c)},
/***/fRKg:
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return s}));
/* harmony import */var o=i("Yz1v");
/**
@license
Copyright (c) 2018 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * @polymerMixin
 */const s=e=>class extends e{static get properties(){return{
/**
       * Number of items fetched at a time from the dataprovider.
       * @attr {number} page-size
       * @type {number}
       */
pageSize:{type:Number,value:50,observer:"_pageSizeChanged"},
/**
       * Total number of items.
       * @type {number | undefined}
       */
size:{type:Number,observer:"_sizeChanged"},
/**
       * Function that provides items lazily. Receives arguments `params`, `callback`
       *
       * `params.page` Requested page index
       *
       * `params.pageSize` Current page size
       *
       * `params.filter` Currently applied filter
       *
       * `callback(items, size)` Callback function with arguments:
       *   - `items` Current page of items
       *   - `size` Total number of items.
       * @type {ComboBoxDataProvider | undefined}
       */
dataProvider:{type:Object,observer:"_dataProviderChanged"},
/** @private */
_pendingRequests:{value:()=>({})},
/** @private */
__placeHolder:{value:new o.a}}}static get observers(){return["_dataProviderFilterChanged(filter, dataProvider)","_dataProviderClearFilter(dataProvider, opened, value)","_warnDataProviderValue(dataProvider, value)","_ensureFirstPage(opened)"]}
/** @private */_dataProviderClearFilter(e,t,i){
// Can't depend on filter in this observer as we don't want
// to clear the filter whenever it's set
e&&!this.loading&&this.filter&&(this.size=void 0,this._pendingRequests={},this.filter="",this.clearCache())}
/** @protected */ready(){super.ready(),this.clearCache(),this.$.overlay.addEventListener("index-requested",e=>{const t=e.detail.index,i=e.detail.currentScrollerPos,o=Math.floor(1.5*this.pageSize);// Ignores the indexes, which are being re-sent during scrolling reset,
// if the corresponding page is around the current scroller position.
// Otherwise, there might be a last pages duplicates, which cause the
// loading indicator hanging and blank items
if(!this._shouldSkipIndex(t,o,i)&&void 0!==t){const e=this._getPageForIndex(t);this._shouldLoadPage(e)&&this._loadPage(e)}})}
/** @private */_dataProviderFilterChanged(){this._shouldFetchData()&&(this.size=void 0,this._pendingRequests={},this.clearCache())}
/** @private */_shouldFetchData(){return!!this.dataProvider&&(this.opened||this.filter&&this.filter.length)}
/** @private */_ensureFirstPage(e){e&&this._shouldLoadPage(0)&&this._loadPage(0)}
/** @private */_shouldSkipIndex(e,t,i){return 0!==i&&e>=i-t&&e<=i+t}
/** @private */_shouldLoadPage(e){if(!this.filteredItems||this._forceNextRequest)return this._forceNextRequest=!1,!0;const t=this.filteredItems[e*this.pageSize];return void 0!==t?t instanceof o.a:void 0===this.size}
/** @private */_loadPage(e){
// make sure same page isn't requested multiple times.
if(!this._pendingRequests[e]&&this.dataProvider){this.loading=!0;const t={page:e,pageSize:this.pageSize,filter:this.filter},i=(o,s)=>{if(this._pendingRequests[e]===i){if(this.filteredItems)this.splice("filteredItems",t.page*t.pageSize,o.length,...o);else{const e=[];e.splice(t.page*t.pageSize,o.length,...o),this.filteredItems=e}// Update selectedItem from filteredItems if value is set
this._isValidValue(this.value)&&this._getItemValue(this.selectedItem)!==this.value&&this._selectItemForValue(this.value),this.opened||this.hasAttribute("focused")||this._commitValue(),this.size=s,delete this._pendingRequests[e],0===Object.keys(this._pendingRequests).length&&(this.loading=!1),0===e&&this.__repositionOverlayDebouncer&&o.length>(this.__maxRenderedItems||0)&&(setTimeout(()=>this.__repositionOverlayDebouncer.flush()),this.__maxRenderedItems=o.length)}};this._pendingRequests[e]||(
// Don't request page if it's already being requested
this._pendingRequests[e]=i,this.dataProvider(t,i))}}
/** @private */_getPageForIndex(e){return Math.floor(e/this.pageSize)}
/**
   * Clears the cached pages and reloads data from dataprovider when needed.
   */clearCache(){if(!this.dataProvider)return;this._pendingRequests={};const e=[];for(let t=0;t<(this.size||0);t++)e.push(this.__placeHolder);this.filteredItems=e,this._shouldFetchData()?this._loadPage(0):this._forceNextRequest=!0}
/** @private */_sizeChanged(e=0){const t=(this.filteredItems||[]).slice(0,e);for(let i=0;i<e;i++)t[i]=void 0!==t[i]?t[i]:this.__placeHolder;this.filteredItems=t,// Cleans up the redundant pending requests for pages > size
// Refers to https://github.com/vaadin/vaadin-flow-components/issues/229
this._flushPendingRequests(e)}
/** @private */_pageSizeChanged(e,t){if(Math.floor(e)!==e||e<1)throw this.pageSize=t,new Error("`pageSize` value must be an integer > 0");this.clearCache()}
/** @private */_dataProviderChanged(e,t){this._ensureItemsOrDataProvider(()=>{this.dataProvider=t})}
/** @private */_ensureItemsOrDataProvider(e){if(void 0!==this.items&&void 0!==this.dataProvider)throw e(),new Error("Using `items` and `dataProvider` together is not supported");this.dataProvider&&!this.filteredItems&&(this.filteredItems=[])}
/** @private */_warnDataProviderValue(e,t){if(e&&""!==t&&(void 0===this.selectedItem||null===this.selectedItem)){const e=this._indexOfValue(t,this.filteredItems);(e<0||!this._getItemLabel(this.filteredItems[e]))&&
/* eslint-disable no-console */
console.warn("Warning: unable to determine the label for the provided `value`. Nothing to display in the text field. This usually happens when setting an initial `value` before any items are returned from the `dataProvider` callback. Consider setting `selectedItem` instead of `value`")}}
/**
   * This method cleans up the page callbacks which refers to the
   * non-existing pages, i.e. which item indexes are greater than the
   * changed size.
   * This case is basically happens when:
   * 1. Users scroll fast to the bottom and combo box generates the
   * redundant page request/callback
   * 2. Server side uses undefined size lazy loading and suddenly reaches
   * the exact size which is on the range edge
   * (for default page size = 50, it will be 100, 200, 300, ...).
   * @param size the new size of items
   * @private
   */_flushPendingRequests(e){if(this._pendingRequests){const t=Math.ceil(e/this.pageSize),i=Object.keys(this._pendingRequests);for(let o=0;o<i.length;o++){const s=parseInt(i[o]);s>=t&&this._pendingRequests[s]([],e)}}}}
/***/},
/***/lFcJ:
/***/function(e,t,i){"use strict";
/* unused harmony export CheckboxElement */
/* harmony import */var o=i("F3iu"),s=i("nduU"),r=i("8u2h"),n=i("6kUO"),a=i("OVu0"),l=i("o5Wi");
/* harmony import */
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * `<vaadin-checkbox>` is a Web Component for customized checkboxes.
 *
 * ```html
 * <vaadin-checkbox>
 *   Make my profile visible
 * </vaadin-checkbox>
 * ```
 *
 * ### Styling
 *
 * The following shadow DOM parts are available for styling:
 *
 * Part name         | Description
 * ------------------|----------------
 * `checkbox`        | The wrapper element for the native <input type="checkbox">
 * `label`           | The wrapper element in which the component's children, namely the label, is slotted
 *
 * The following state attributes are available for styling:
 *
 * Attribute    | Description | Part name
 * -------------|-------------|--------------
 * `active`     | Set when the checkbox is pressed down, either with mouse, touch or the keyboard. | `:host`
 * `disabled`   | Set when the checkbox is disabled. | `:host`
 * `focus-ring` | Set when the checkbox is focused using the keyboard. | `:host`
 * `focused`    | Set when the checkbox is focused. | `:host`
 * `indeterminate` | Set when the checkbox is in indeterminate mode. | `:host`
 * `checked` | Set when the checkbox is checked. | `:host`
 * `empty` | Set when there is no label provided. | `label`
 *
 * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
 *
 * @extends PolymerElement
 * @mixes ElementMixin
 * @mixes ControlStateMixin
 * @mixes ThemableMixin
 * @mixes GestureEventListeners
 * @demo demo/index.html
 */
class d extends(Object(a.a)(Object(n.a)(Object(r.a)(Object(s.a)(o.a))))){static get template(){return l.a`<style>:host{display:inline-block}:host([hidden]){display:none!important}label{display:inline-flex;align-items:baseline;outline:0}[part=checkbox]{position:relative;display:inline-block;flex:none}input[type=checkbox]{position:absolute;top:0;left:0;right:0;width:100%;height:100%;opacity:0;cursor:inherit;margin:0}:host([disabled]){-webkit-tap-highlight-color:transparent}</style><label><span part="checkbox"><input type="checkbox" checked="{{checked::change}}" disabled\$="[[disabled]]" indeterminate="{{indeterminate::change}}" role="presentation" tabindex="-1"> </span><span part="label"><slot></slot></span></label>`}static get is(){return"vaadin-checkbox"}static get version(){return"2.5.0"}static get properties(){return{
/**
       * True if the checkbox is checked.
       * @type {boolean}
       */
checked:{type:Boolean,value:!1,notify:!0,observer:"_checkedChanged",reflectToAttribute:!0},
/**
       * Indeterminate state of the checkbox when it's neither checked nor unchecked, but undetermined.
       * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox#Indeterminate_state_checkboxes
       * @type {boolean}
       */
indeterminate:{type:Boolean,notify:!0,observer:"_indeterminateChanged",reflectToAttribute:!0,value:!1},
/**
       * The value given to the data submitted with the checkbox's name to the server when the control is inside a form.
       */
value:{type:String,value:"on"},
/** @private */
_nativeCheckbox:{type:Object}}}constructor(){super(),
/**
     * @type {string}
     * Name of the element.
     */
this.name}get name(){return this.checked?this._storedName:""}set name(e){this._storedName=e}ready(){super.ready(),this.setAttribute("role","checkbox"),this._nativeCheckbox=this.shadowRoot.querySelector('input[type="checkbox"]'),this.addEventListener("click",this._handleClick.bind(this)),this._addActiveListeners();const e=this.getAttribute("name");e&&(this.name=e),this.shadowRoot.querySelector('[part~="label"]').querySelector("slot").addEventListener("slotchange",this._updateLabelAttribute.bind(this)),this._updateLabelAttribute()}
/** @private */_updateLabelAttribute(){const e=this.shadowRoot.querySelector('[part~="label"]'),t=e.firstElementChild.assignedNodes();this._isAssignedNodesEmpty(t)?e.setAttribute("empty",""):e.removeAttribute("empty")}
/** @private */_isAssignedNodesEmpty(e){
// The assigned nodes considered to be empty if there is no slotted content or only one empty text node
return 0===e.length||1==e.length&&e[0].nodeType==Node.TEXT_NODE&&""===e[0].textContent.trim()}
/** @private */_checkedChanged(e){this.indeterminate?this.setAttribute("aria-checked","mixed"):this.setAttribute("aria-checked",Boolean(e))}
/** @private */_indeterminateChanged(e){e?this.setAttribute("aria-checked","mixed"):this.setAttribute("aria-checked",this.checked)}
/** @private */_addActiveListeners(){
// DOWN
this._addEventListenerToNode(this,"down",e=>{this.__interactionsAllowed(e)&&this.setAttribute("active","")}),// UP
this._addEventListenerToNode(this,"up",()=>this.removeAttribute("active")),// KEYDOWN
this.addEventListener("keydown",e=>{this.__interactionsAllowed(e)&&32===e.keyCode&&(e.preventDefault(),this.setAttribute("active",""))}),// KEYUP
this.addEventListener("keyup",e=>{this.__interactionsAllowed(e)&&32===e.keyCode&&(e.preventDefault(),this._toggleChecked(),this.removeAttribute("active"),this.indeterminate&&(this.indeterminate=!1))})}
/**
   * @return {!HTMLInputElement}
   * @protected
   */get focusElement(){return this.shadowRoot.querySelector("input")}
/**
   * True if users' interactions (mouse or keyboard)
   * should toggle the checkbox
   */__interactionsAllowed(e){return!this.disabled&&"a"!==e.target.localName;// https://github.com/vaadin/vaadin-checkbox/issues/63
}
/** @private */_handleClick(e){this.__interactionsAllowed(e)&&(this.indeterminate?(
/*
         * Required for IE 11 and Edge.
         * See issue here: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/7344418/
         */
this.indeterminate=!1,e.preventDefault(),this._toggleChecked()):e.composedPath()[0]!==this._nativeCheckbox&&(e.preventDefault(),this._toggleChecked()))}
/** @protected */_toggleChecked(){this.checked=!this.checked,this.dispatchEvent(new CustomEvent("change",{composed:!1,bubbles:!0}))}
/**
   * Fired when the user commits a value change.
   *
   * @event change
   */}customElements.define(d.is,d)},
/***/uNQt:
/***/function(e,t,i){"use strict";
/* harmony import */i("w832"),i("82cM"),i("C/Bj")
/* harmony import */},
/***/w832:
/***/function(e,t,i){"use strict";
/* harmony import */i("h/KH"),i("fBRI"),i("y+0W"),i("oVvL"),i("a+L4")
/* harmony import */;const o=i("o5Wi").a`<dom-module id="lumo-combo-box-overlay" theme-for="vaadin-combo-box-overlay"><template><style include="lumo-overlay lumo-menu-overlay-core">[part=content]{padding:0}:host{--iron-list-items-container:{border-width:var(--lumo-space-xs);border-style:solid;border-color:transparent};}:host([opened]){--iron-list-items-container_-_border-width:var(--lumo-space-xs);--iron-list-items-container_-_border-style:solid;--iron-list-items-container_-_border-color:transparent}:host(:not([closing])) [part~=content]{min-height:calc(2 * var(--lumo-space-s) + var(--lumo-icon-size-s))}[part~=overlay]{position:relative}:host([loading]) [part~=loader]{box-sizing:border-box;width:var(--lumo-icon-size-s);height:var(--lumo-icon-size-s);position:absolute;z-index:1;left:var(--lumo-space-s);right:var(--lumo-space-s);top:var(--lumo-space-s);margin-left:auto;margin-inline-start:auto;margin-inline-end:0;border:2px solid transparent;border-color:var(--lumo-primary-color-50pct) var(--lumo-primary-color-50pct) var(--lumo-primary-color) var(--lumo-primary-color);border-radius:calc(.5 * var(--lumo-icon-size-s));opacity:0;animation:1s linear infinite lumo-combo-box-loader-rotate,.3s .1s lumo-combo-box-loader-fade-in both;pointer-events:none}@keyframes lumo-combo-box-loader-fade-in{0%{opacity:0}100%{opacity:1}}@keyframes lumo-combo-box-loader-rotate{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}:host([loading][dir=rtl]) [part~=loader]{left:auto;margin-left:0;margin-right:auto;margin-inline-start:0;margin-inline-end:auto}</style></template></dom-module>`;document.head.appendChild(o.content)}}]);